import React, {useState, useEffect, useCallback, useRef, memo } from 'react';
import { 
         Avatar,
         Card,
         CardContent,
         Chip,
         Dialog,
         DialogContent,
         DialogTitle,
         Grid,
         IconButton,
         LinearProgress,
         MenuItem,
         Paper,
         Switch,
         Table,
         TableBody,
         TableCell,
         TableContainer,
         TableHead,
         TableRow,
         TextField,
         Typography,
         Tooltip,
         Divider,
        } from '@material-ui/core';
import { 
            Block as BlockIcon,
            CheckCircle as CheckCircleIcon,
            Dns as DnsIcon,
            EmojiObjects as EmojiObjectsIcon,
            Event as EventIcon,
            GpsFixed as GpsFixedIcon,
            MonetizationOn as MonetizationOnIcon,
            Place as PlaceIcon,
            Router as RouterIcon,
            Speed as SpeedIcon,
            Sync as SyncIcon,
            Whatshot as WhatshotIcon,
            WifiTethering as WifiTetheringIcon,
            AddCircle as AddCircleIcon,
            PhotoCamera as PhotoIcon,
        } from '@material-ui/icons';
import mapboxgl from 'mapbox-gl';
import handleNetWatch from '../helpers/handleNetWatch';
import copy from "copy-to-clipboard";  
import UploadElementYounet from './UploadElementYounet';
import capitalize from '../../Elementos/Capitalize';
import { Autocomplete } from '@material-ui/lab';
import swal from 'sweetalert';
import PdfInstalacionRadio from '../PdfInstalacionRadio';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import { 
    Button as ButtonAntd,
    Checkbox as CheckboxAntd,
    Modal as ModalAntd,
    Popconfirm, 
    Switch as SwitchAntd,
    Tooltip as TooltipAntd, 
} from 'antd';
import { 
    ApiOutlined as ApiOutlinedIcon,
    ClusterOutlined as ClusterOutlinedIcon,
    ChromeFilled as ChromeOutlinedIcon,
    CopyOutlined as ContentCopyIcon, 
    DeleteOutlined as DeleteOutlinedIcon,
    FilePdfOutlined as FilePdfOutlinedIcon,
    InteractionOutlined as InteractionOutlinedIcon,
    LoadingOutlined as LoadingOutlinedIcon,
    NodeIndexOutlined,
    PoweroffOutlined as PoweroffOutlinedIcon,
    RedoOutlined as RedoOutlinedIcon, 
    ReloadOutlined as ReloadOutlinedIcon,
    RadiusSettingOutlined as RadiusSettingOutlinedIcon,
    SaveOutlined as SaveOutlinedIcon,
    SettingOutlined as SettingOutlinedIcon,
    VerifiedOutlined as VerifiedOutlinedIcon,
    WifiOutlined as WifiOutlinedIcon
   } from '@ant-design/icons';
import ConvertArrToJson from '../helpers/ConvertArrToJson';
import isValidCoordinates from '../helpers/isValidCoordinates';

const getCuentas = [ 'CiberCafe', 'Corporativo', 'Residencial', 'Otros' ];
const onlyMeses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

const ElementServiciosRadio = memo((props)=>{
    const { 
            authTokens,
            classes,
            data,
            dataCliente, 
            enqueueSnackbar,
            getAddClientMikrotik, 
            getArrIdForMikrotik,
            // getEquiposAll,
            getPlanes,
            getTecnicos, 
            handleBorrarServicio, 
            handleBorrarServicioMongo,  
            handlePostServicio, 
            handlePutServicio, 
            index, 
            zonaSelected, 
    } = props;
    const [ statusServicioAdd, setStatusServicioAdd ] = useState(true);
    const [ DatosD, setDatosD] = useState({
        Instalacion:'',
        AddressIp:'',
        Plan:'',
        ValorInstalacion:'',
        idForMikrotik:'',
        ZonaService:zonaSelected.Zona,
        TipoPagoBoolean:true,
        CorteAutomatico:true,
        StatusIns:false,
        Coordenadas:'',
        Router:'',
        MacRouter:'',
        Modelo:'',
        MacModelo:'',
        Red:'',
        Mascara:'',
        Status:'',
        UserMk:'admin',
        PassMk:'Apolo$$2019',
        IVA:false,
        DiaNotificacion:1,
        DiasCorte:4,
        isTelnet:false,
        TipoCuenta:'',
        TiempoPermanencia:'',
        isFree:false
    });
    const [ isSaving, setSaving ] = useState(false);
    const [ isNotificacion, setNotificacion ] = useState(false);
    const [ getInfoBackup, setInfoBackup ] = useState({});
    const [ Planes, setPlanes ] = useState([]);
    const [ isReadyPdf, setReadyPdf ] = useState(false);
    const [ onlyRouters, setOnlyRouters ] = useState([]);
    const [ macsModelosArr, setMacsModelosArr ] = useState([]);
    const [ macsRouters, setMacsRouters ] = useState([]);
    const [ getArrIpService, setArrIpService ] = useState([]);
    const [ openPhoto, setOpenPhoto ] = useState(false);
    const [ getArrPhotos, setArrPhotos ] = useState([]);
    const [ getAvance, setAvance ] = useState(0);
    const [ onlyModelos, setOnlyModelos ] = useState([]);
    const [ isDstPort, setDstPort ] = useState(false);
    const [ informacionAPCPE, setInformacionAPCPE ] = useState([]);
    const [ continuoInformacionCPE, setContinuoInformacionCPE ] = useState(false);
    const [ isInfoCharging, setInfoCharging ] = useState(false);
    const [ isInfoCharging2, setInfoCharging2 ] = useState(false);
    const [ openDialogInformacionCPE, setOpenDialogInformacionCPE ] = useState(false);
    const [ isReadyCPE, setReadyCPE ] = useState(false);
    const [ getOpenStatusCPE, setOpenStatusCPE ] = useState(false);
    const [ getInfoCPE, setInfoCPE ] = useState({});
    const [ isReadyInterfaces, setReadyInterfaces ] = useState(false);
    const [ getOpenInterfaces, setOpenInterfaces ] = useState(false);
    const [ getInterfaces, setInterfaces ] = useState({});
    const [ isInterfacesCharging, setInterfacesCharging]  = useState(false);
    const [ isNewService, setNewService ] = useState(false);
    const [ isRebootCPE, setRebootCPE ] = useState(false);
    const [ getOpenComandos, setOpenComandos ] = useState(false);
    const [ isRemovingArp, setRemovingArp ] = useState(false);
    const [ getPassCPE, setPassCPE ] = useState(false);
    const [ getInfoWlan, setInfoWlan ] = useState(false);
    const [ getSincronizando, setSincronizando ] = useState(false);
    const [ getSincronizando2, setSincronizando2 ] = useState(false);
    const [ getCoord, setCoord ] = useState('-2.201567808901885, -79.93395424851998, ');
    const [ isSearchingPingOnu, setSearchingPingOnu ] = useState(false);
    const [ isUnify, setUnify ] = useState(false);
    const [ isServActive, setServActive ] = useState(false);
    const [ isOfflineServ, setOfflineServ ] = useState(false);
    const [ isCreateInstalacion, setCreateInstalacion ] = useState(true);
    const [ isCreateInvoice, setCreateInvoice ] = useState(true);
    const [ stock, setStock ] = useState([]);
    const [ getArrAp] = useState([]);
    const [ getArrIp, setArrIp] = useState([]);
    const [ getArrIpIptv, setArrIpIptv] = useState([]);
    const [ isIpsCharged, setIpsCharged] = useState(false);
    const [ getArrIpServiceIptv, setArrIpServiceIptv ] = useState([]);
    const [ getEquiposAll, setEquiposAll ] = useState([]);
    const mapDiv = useRef();
    const mapa = useRef();

    useEffect(()=>{

        if(data.isNew){ 
            (async ()=>{
                if (zonaSelected.isIptv) {
                    fetch('/api/getIpsQueueTree', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                        .then(response => response.json())
                        .then((result) => {
                            let arrComp = [];
                            for (const x in zonaSelected.SubnetIptv) {
                                let data = zonaSelected.SubnetIptv[x];
                                let rangeZone = data.Red.split('.');
                                const arr4 = [];
                                const arrComplete4 = [];
                                for (const x in result) {
                                    for (const y in result[x]) {
                                        if (result[x][y].field === 'address') {
                                            let val = result[x][y].value.split('.');
                                            let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                            if (data.Red.toString() === range.toString()) arr4.push(result[x][y].value);
                                        }
                                    };
                                };
                                for (let i = 2; i < 255; i++) {
                                    let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                    if (arr4.includes(number)) {
                                        const objeto = {};
                                        for (const x in result) {
                                            for (const y in result[x]) {
                                                if (result[x][y].field === 'address') {
                                                    if (result[x][y].value === number) objeto.idForMikrotik = result[x][6] ? result[x][6].value : null
                                                }
                                            };
                                        };
                                        objeto.IP = number;
                                        objeto.Status = 'NO DISPONIBLE';
                                        arrComplete4.push(objeto);
                                    } else {
                                        const objeto = {};
                                        objeto.Status = 'DISPONIBLE';
                                        objeto.IP = number;
                                        arrComplete4.push(objeto);
                                    }
                                }
                                arrComp = arrComp.concat(arrComplete4);
                            };
                            setArrIpIptv(arrComp);
                        });
                }
                
                if(zonaSelected.sysintercom){
                    fetch('/api/getIpsSimpleQueue',{
                        method:'POST',
                        body: JSON.stringify({InfoZona:zonaSelected}),
                        headers:{'Content-Type': 'application/json'}
                    }) 
                    .then(response=> response.json())
                    .then((result) =>{
                        let arrComp = [];
                        for(const x in zonaSelected.Subnet){
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for(const x in result){
                                for(const y in result[x]){
                                    if(result[x][y].field === 'target'){ 
                                        if(result[x][y].value.split('/').length === 2){
                                            let val_0 = result[x][y].value.split('/')[0].toString();
                                            let val = val_0.split('.');
                                            let range = `${val[0].toString()}.${val[1].toString()}.${val[2]?.toString()}.0`
                                            if(data.Red.toString() === range.toString()) arr4.push(val_0);
                                        }
                                    }
                                };
                            };
                            for(let i = 2; i < 255; i++ ){
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if(arr4.includes(number)){
                                    const objeto = {};
                                    for(const x in result){
                                        for(const y in result[x]){
                                            if(result[x][y].field === 'target'){ 
                                                if(result[x][y].value.split('/').length === 2){
                                                    let val_0 = result[x][y].value.split('/')[0].toString();
                                                    if(val_0 === number) {
                                                        objeto.idForMikrotik = result[x][1].value ;
                                                        objeto.idFromMikrotikSimple = result[x][0].value ;
                                                    }
                                                }
    
                                            }
                                        };
                                    };
                                    objeto.Status = 'NO DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);                                           
                                }else{
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        fetch('/api/getIpsQueueTree',{
                            method:'POST',
                            body: JSON.stringify({InfoZona:zonaSelected}),
                            headers:{
                                'Content-Type': 'application/json'
                            }
                        }) 
                        .then(response=> response.json())
                        .then(async (result2) =>{    
                            const jsonNew = await ConvertArrToJson(result2);
                            let arrComp2 = [];
                            for(const x in zonaSelected.Subnet){
                                let data = zonaSelected.Subnet[x];
                                let rangeZone = data.Red.split('.');
                                const arrComplete8 = [];
                                
                                const arr8 = jsonNew.filter(el=>{
                                    let val = el.address?.split('.');
                                    let range = `${val[0].toString()}.${val[1].toString()}.${val[2]?.toString()}.0`;
                                    if(data.Red.toString() === range.toString()) return true;
                                    else  return false;
                                }).map(el=>el.address).splice(1);
    
                                for(let i = 2; i < 255; i++ ){
                                    let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                    if(arr8.includes(number)){
                                        const findEl = jsonNew.find(el=> el.address === number);
                                        const objeto = {};
                                        objeto.idForMikrotik = findEl?.comment;
                                        objeto.idFromMikrotik = findEl['.id'];
                                        objeto.isActive = findEl.list ? findEl.list === 'Moroso' ? false : true : false ;
                                        objeto.IP = number;
                                        objeto.Status = 'NO DISPONIBLE';
                                        arrComplete8.push(objeto);
                                    }else{
                                        const objeto = {};
                                        objeto.Status = 'DISPONIBLE';
                                        objeto.IP = number;
                                        arrComplete8.push(objeto);
                                    }
                                }
                                arrComp2 = arrComp2.concat(arrComplete8);
                            };
                            const arrNew_ = arrComp.map(el=>{
                                const objeto = {...el};
                                const arrF_ = arrComp2.find(el2=> el2.IP === el.IP);
                                objeto.idFromMikrotik = arrF_?.idFromMikrotik;
                                objeto.isActive = arrF_?.isActive;
                                return objeto;
                            })
                            setArrIp(arrNew_);
                            setIpsCharged(true);
                            
                        });        
                    }); 
                } else if(zonaSelected.simpleQueue){
                    fetch('/api/getIpsSimpleQueue', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: { 'Content-Type': 'application/json' }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.Subnet) {
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'target') {
                                        if (result[x][y].value.split('/').length === 2) {
                                            let val_0 = result[x][y].value.split('/')[0].toString();
                                            let val = val_0.split('.');
                                            let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                            if (data.Red.toString() === range.toString()) arr4.push(val_0);
                                        }
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'target') {
                                                if (result[x][y].value.split('/').length === 2) {
                                                    let val_0 = result[x][y].value.split('/')[0].toString();
                                                    if (val_0 === number){ 
                                                        objeto.idForMikrotik = result[x][1].value;
                                                        objeto.idFromMikrotik = result[x][0].value;
                                                    }
                                                }
    
                                            }
                                        };
                                    };
                                    objeto.Status = 'NO DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        }
                        setArrIp(arrComp);
                        setIpsCharged(true);
                        
                    });
                } else if(zonaSelected.queueTree) {
                    fetch('/api/getIpsQueueTree', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.Subnet) {
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'address') {
                                        let val = result[x][y].value.split('.');
                                        let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                        if (data.Red.toString() === range.toString()) arr4.push(result[x][y].value);
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'address') {
                                                if (result[x][y].value === number){ 
                                                    objeto.idForMikrotik = result[x][6] ? result[x][6].value : null;
                                                    objeto.Plan = result[x][1].value;
                                                    objeto.idFromMikrotik = result[x][0].value;
                                                    objeto.isActive = result[x][1]?.value === 'Moroso' ? false : true;
                                                }
                                            }
                                        };
                                    };
                                    
                                    objeto.IP = number;
                                    objeto.Status = 'NO DISPONIBLE';
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        setArrIp(arrComp);
                        setIpsCharged(true);
                        
                    });
                } else if(zonaSelected.ppoeList) {
                    fetch('/api/getIpsPPPoe', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.Subnet) {
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'remote-address') {
                                        let val = result[x][y].value.split('.');
                                        let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                        if (data.Red.toString() === range.toString()) arr4.push(result[x][y].value);
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'remote-address') {
                                                if (result[x][y].value === number){ 
                                                    objeto.idForMikrotik = result[x][1].value;
                                                    objeto.idFromMikrotik = result[x][0].value;
                                                }
                                            }
                                        };
                                    };
                                    objeto.Status = 'NO DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        fetch('/api/mikrotik/clientesPpoeListActive',{
                            method:'POST',
                            body: JSON.stringify(zonaSelected),
                            headers:{
                                'Content-Type': 'application/json'
                            }
                        }) 
                        .then(response2=> response2.json())
                        .then(result2 =>{
                            const arr2 = [];
                            result2.forEach(value => {
                                const objeto = {};
                                value.forEach((value2, index2)=>{
                                let splitKey =  value2.field.toString().split('-');
                                switch(splitKey.length){
                                    case 2: 
                                        let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                                        objeto[key2] = value2.value; 
                                        break;
                                    case 3: 
                                        let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                                        objeto[key3] = value2.value;
                                        break;
                                    case 4: 
                                        let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                                        objeto[key4] = value2.value;
                                        break;
                                    default:
                                        let splitKey2 =  value2.field.toString().split('.');
                                        if(splitKey2.length === 2){
                                        objeto.idGeneralActive = value2.value;
                                        }else{
                                        objeto[value2.field] = value2.value;                      
                                        }
                                        break;
                                }
                                })
                                arr2.push(objeto);
                            });
                            const arrActive = arr2.map(value=>value.address);
                            const arrResult = arrComp.map(value=>{
                                const objeto5 = {...value};
                                if(arrActive.includes(value.IP)){
                                    objeto5.isActive = true;
                                    return(objeto5);
                                }else{
                                    objeto5.isActive = false;
                                    return objeto5;
                                }
                            });
                            setArrIp(arrResult);
                            setIpsCharged(true);
                            
                        });
                    });
                }  
    
            })();
            setInfoBackup({
                MacModelo:'',
                MacRouter:''
            })
            setNewService(true);
            setPlanes(zonaSelected.planLocal ? zonaSelected.Planes : getPlanes);
            setDatosD({...DatosD, 
                idUiid:data.idUiid, 
                FOptica:data.FOptica, 
                TipoServicio:data.TipoServicio, 
                TipoServicioMk:data.TipoServicioMk, 
                ZonaService:zonaSelected.Zona, 
                TipoPagoBoolean:true, 
                CorteAutomatico:true, 
                Status:'Activo',
                Ciudad:zonaSelected.Ciudad,
                Canton:zonaSelected.Canton,
                Parroquia:zonaSelected.Parroquia,
                Provincia:zonaSelected.Provincia,
                MacRouter:'', 
                RouterNSerie:'',
                MacModelo:'',
            }); 
            const  handleSearchEl = async ()=>{
                const getEquiposA = await fetch(`/api/EquiposAls/byEmpresa/${authTokens.Empresa}`);
                const jsnEquiposA = await getEquiposA.json();
                setEquiposAll(jsnEquiposA);
                const getStock = await fetch(`/api/Stocks/byEmpresa/${authTokens.Empresa}`);
                const jsnStock = await getStock.json();
                setStock(jsnStock);
                const arr = jsnStock.filter(elR=>elR.Tipo === 'ROUTER');
                const arrCpe = jsnStock.filter(elR=>elR.Tipo === 'CPE');
                const arr_1 = arr.map(el=>el.Modelo);
                const arr_2 = new Set(arr_1);
                const arr_3 = [...arr_2];
                const arr_4 = arrCpe.map(el=>el.Modelo);
                const arr_5 = new Set(arr_4);
                const arr_6 = [...arr_5];
                setOnlyRouters(arr_3);
                setOnlyModelos(arr_6);
            }; handleSearchEl();
            var map = new mapboxgl.Map({
                container: mapDiv.current,
                style: 'mapbox://styles/mapbox/satellite-v9',
                center: [ 
                    data.Coordenadas === '' ? '-79.93395424851998' : 
                    data.Coordenadas === undefined ? '-79.93395424851998' : 
                    isValidCoordinates(data.Coordenadas) ? 
                    data.Coordenadas.split(',')[1] : '-79.93395424851998', 
                    data.Coordenadas === '' ? '-2.201567808901885' : 
                    data.Coordenadas === undefined ? '-2.201567808901885' : 
                    isValidCoordinates(data.Coordenadas) ? 
                    data.Coordenadas.split(',')[0]  : '-2.201567808901885' ],
                zoom: 16.80 
            });
    
            const marker = new mapboxgl.Marker();
                marker.id = data._id;
                marker
                    .setLngLat(
                        [ 
                            data.Coordenadas === '' ? '-79.93395424851998' : 
                            data.Coordenadas === undefined ? '-79.93395424851998' : 
                            isValidCoordinates(data.Coordenadas) ? 
                            data.Coordenadas.split(',')[1] : '-79.93395424851998', 
                            data.Coordenadas === '' ? '-2.201567808901885' : 
                            data.Coordenadas === undefined ? '-2.201567808901885' : 
                            isValidCoordinates(data.Coordenadas) ? 
                            data.Coordenadas.split(',')[0]  : '-2.201567808901885' ]
                    )
                    .addTo( map )
                    .setDraggable(true)
    
                marker.on('dragend', ({target})=>{
                    setCoord(`${target._lngLat.lat.toString()}, ${target._lngLat.lng.toString()}`);
                })
    
            mapa.current = map;
        }else{
            (async ()=>{
                if (zonaSelected.isIptv) {
                    fetch('/api/getIpsQueueTree', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.SubnetIptv) {
                            let data = zonaSelected.SubnetIptv[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'address') {
                                        let val = result[x][y].value.split('.');
                                        let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                        if (data.Red.toString() === range.toString()) arr4.push(result[x][y].value);
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'address') {
                                                if (result[x][y].value === number) objeto.idForMikrotik = result[x][6] ? result[x][6].value : null
                                            }
                                        };
                                    };
                                    objeto.IP = number;
                                    objeto.Status = 'NO DISPONIBLE';
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        setArrIpIptv(arrComp);
                        const arrIptv = [];
                        for(const x in arrComp){
                            let redIp = arrComp[x].IP.split('.');
                            let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                            if(red.toString() === data.RedIptv.toString()) arrIptv.push(arrComp[x]);
                        };
                        setArrIpServiceIptv(arrIptv);
                    });
                }
                
                if(zonaSelected.sysintercom){
                    fetch('/api/getIpsSimpleQueue',{
                        method:'POST',
                        body: JSON.stringify({InfoZona:zonaSelected}),
                        headers:{'Content-Type': 'application/json'}
                    }) 
                    .then(response=> response.json())
                    .then((result) =>{
                        console.log(result)
                        let arrComp = [];
                        for(const x in zonaSelected.Subnet){
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for(const x in result){
                                for(const y in result[x]){
                                    if(result[x][y].field === 'target'){ 
                                        if(result[x][y].value.split('/').length === 2){
                                            let val_0 = result[x][y].value.split('/')[0].toString();
                                            let val = val_0.split('.');
                                            if(val.length > 2){
                                                let range = `${val[0].toString()}.${val[1].toString()}.${val[2]?.toString()}.0`
                                                if(data.Red.toString() === range.toString()) arr4.push(val_0);
                                            }
                                        }
                                    }
                                };
                            };
                            for(let i = 2; i < 255; i++ ){
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if(arr4.includes(number)){
                                    const objeto = {};
                                    for(const x in result){
                                        for(const y in result[x]){
                                            if(result[x][y].field === 'target'){ 
                                                if(result[x][y].value.split('/').length === 2){
                                                    let val_0 = result[x][y].value.split('/')[0].toString();
                                                    if(val_0 === number) {
                                                        objeto.idForMikrotik = result[x][1].value ;
                                                        objeto.idFromMikrotikSimple = result[x][0].value ;
                                                    }
                                                }
    
                                            }
                                        };
                                    };
                                    objeto.Status = 'NO DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);                                           
                                }else{
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        fetch('/api/getIpsQueueTree',{
                            method:'POST',
                            body: JSON.stringify({InfoZona:zonaSelected}),
                            headers:{
                                'Content-Type': 'application/json'
                            }
                        }) 
                        .then(response=> response.json())
                        .then(async (result2) =>{    
                            const jsonNew = await ConvertArrToJson(result2);
                            let arrComp2 = [];
                            for(const x in zonaSelected.Subnet){
                                let data = zonaSelected.Subnet[x];
                                let rangeZone = data.Red.split('.');
                                const arrComplete8 = [];
                                
                                const arr8 = jsonNew.filter(el=>{
                                    let val = el.address?.split('.');
                                    if(val.length > 2){
                                        let range = `${val[0].toString()}.${val[1].toString()}.${val[2]?.toString()}.0`;
                                        if(data.Red.toString() === range.toString()) return true;
                                        else  return false;
                                    }else{
                                        return false; 
                                    }
                                }).map(el=>el.address).splice(1);
    
                                for(let i = 2; i < 255; i++ ){
                                    let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                    if(arr8.includes(number)){
                                        const findEl = jsonNew.find(el=> el.address === number);
                                        const objeto = {};
                                        objeto.idForMikrotik = findEl?.comment;
                                        objeto.idFromMikrotik = findEl['.id'];
                                        objeto.isActive = findEl.list ? findEl.list === 'Moroso' ? false : true : false ;
                                        objeto.IP = number;
                                        objeto.Status = 'NO DISPONIBLE';
                                        arrComplete8.push(objeto);
                                    }else{
                                        const objeto = {};
                                        objeto.Status = 'DISPONIBLE';
                                        objeto.IP = number;
                                        arrComplete8.push(objeto);
                                    }
                                }
                                arrComp2 = arrComp2.concat(arrComplete8);
                            };
                            const arrNew_ = arrComp.map(el=>{
                                const objeto = {...el};
                                const arrF_ = arrComp2.find(el2=> el2.IP === el.IP);
                                objeto.idFromMikrotik = arrF_?.idFromMikrotik;
                                objeto.isActive = arrF_?.isActive;
                                return objeto;
                            })
                            const findIp = arrNew_.find(el=> el.IP === data.AddressIp);
                            findIp?.isActive && setServActive(true);
                            const arr2_ = [];
                            for(const x in arrNew_){
                                let redIp = arrNew_[x].IP.split('.');
                                let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                                if(red.toString() === data.Red.toString()) arr2_.push(arrNew_[x]);
                            };
                            setArrIpService(arr2_);
                            setArrIp(arrNew_);
                            setIpsCharged(true);
                        });        
                    });
                } else if(zonaSelected.simpleQueue){
                    fetch('/api/getIpsSimpleQueue', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: { 'Content-Type': 'application/json' }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.Subnet) {
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'target') {
                                        if (result[x][y].value.split('/').length === 2) {
                                            let val_0 = result[x][y].value.split('/')[0].toString();
                                            let val = val_0.split('.');
                                            let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                            if (data.Red.toString() === range.toString()) arr4.push(val_0);
                                        }
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'target') {
                                                if (result[x][y].value.split('/').length === 2) {
                                                    let val_0 = result[x][y].value.split('/')[0].toString();
                                                    if (val_0 === number){ 
                                                        objeto.idForMikrotik = result[x][1].value;
                                                        objeto.idFromMikrotik = result[x][0].value;
                                                    }
                                                }
    
                                            }
                                        };
                                    };
                                    objeto.Status = 'NO DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        }
                        const findIp = arrComp.find(el=> el.IP === data.AddressIp);
                        findIp?.isActive && setServActive(true);
                        const arr2_ = [];
                        for(const x in arrComp){
                            let redIp = arrComp[x].IP.split('.');
                            let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                            if(red.toString() === data.Red.toString()) arr2_.push(arrComp[x]);
                        };
                        setArrIpService(arr2_);
                        setArrIp(arrComp);
                        setIpsCharged(true);
                    });
                } else if(zonaSelected.queueTree) {
                    fetch('/api/getIpsQueueTree', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.Subnet) {
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'address') {
                                        let val = result[x][y].value.split('.');
                                        let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                        if (data.Red.toString() === range.toString()) arr4.push(result[x][y].value);
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'address') {
                                                if (result[x][y].value === number){ 
                                                    objeto.idForMikrotik = result[x][6] ? result[x][6].value : null;
                                                    objeto.Plan = result[x][1].value;
                                                    objeto.idFromMikrotik = result[x][0].value;
                                                    objeto.isActive = result[x][1]?.value === 'Moroso' ? false : true;
                                                }
                                            }
                                        };
                                    };
                                    
                                    objeto.IP = number;
                                    objeto.Status = 'NO DISPONIBLE';
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        const findIp = arrComp.find(el=> el.IP === data.AddressIp);
                        findIp?.isActive && setServActive(true);
                        const arr2_ = [];
                        for(const x in arrComp){
                            let redIp = arrComp[x].IP.split('.');
                            let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                            if(red.toString() === data.Red.toString()) arr2_.push(arrComp[x]);
                        };
                        setArrIpService(arr2_);
                        setArrIp(arrComp);
                        setIpsCharged(true);
                        
                    });
                } else if(zonaSelected.ppoeList) {
                    fetch('/api/getIpsPPPoe', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.Subnet) {
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'remote-address') {
                                        let val = result[x][y].value.split('.');
                                        let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                        if (data.Red.toString() === range.toString()) arr4.push(result[x][y].value);
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'remote-address') {
                                                if (result[x][y].value === number){ 
                                                    objeto.idForMikrotik = result[x][1].value;
                                                    objeto.idFromMikrotik = result[x][0].value;
                                                }
                                            }
                                        };
                                    };
                                    objeto.Status = 'NO DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        fetch('/api/mikrotik/clientesPpoeListActive',{
                            method:'POST',
                            body: JSON.stringify(zonaSelected),
                            headers:{
                                'Content-Type': 'application/json'
                            }
                        }) 
                        .then(response2=> response2.json())
                        .then(result2 =>{
                            const arr2 = [];
                            result2.forEach(value => {
                                const objeto = {};
                                value.forEach((value2, index2)=>{
                                let splitKey =  value2.field.toString().split('-');
                                switch(splitKey.length){
                                    case 2: 
                                        let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                                        objeto[key2] = value2.value; 
                                        break;
                                    case 3: 
                                        let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                                        objeto[key3] = value2.value;
                                        break;
                                    case 4: 
                                        let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                                        objeto[key4] = value2.value;
                                        break;
                                    default:
                                        let splitKey2 =  value2.field.toString().split('.');
                                        if(splitKey2.length === 2){
                                        objeto.idGeneralActive = value2.value;
                                        }else{
                                        objeto[value2.field] = value2.value;                      
                                        }
                                        break;
                                }
                                })
                                arr2.push(objeto);
                            });
                            const arrActive = arr2.map(value=>value.address);
                            const arrResult = arrComp.map(value=>{
                                const objeto5 = {...value};
                                if(arrActive.includes(value.IP)){
                                    objeto5.isActive = true;
                                    return(objeto5);
                                }else{
                                    objeto5.isActive = false;
                                    return objeto5;
                                }
                            });
                            const findIp = arrResult.find(el=> el.IP === data.AddressIp);
                            findIp?.isActive && setServActive(true);
                            const arr2_ = [];
                            for(const x in arrResult){
                                let redIp = arrResult[x].IP.split('.');
                                let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                                if(red.toString() === data.Red.toString()) arr2_.push(arrResult[x]);
                            };
                            setArrIpService(arr2_);
                            setArrIp(arrResult);
                            setIpsCharged(true);
                        });
                    });
                }  
    
            })();
            setNewService(false);
            setDatosD(data); 
            setInfoBackup(data);
            setStatusServicioAdd(false);
            setCreateInstalacion(false);
            setCreateInvoice(false);
            setPlanes(zonaSelected.planLocal ? zonaSelected.Planes : getPlanes);
            const  handleSearchEl = async ()=>{
                const getEquiposA = await fetch(`/api/EquiposAls/byEmpresa/${authTokens.Empresa}`);
                const jsnEquiposA = await getEquiposA.json();
                setEquiposAll(jsnEquiposA);
                const getStock = await fetch(`/api/Stocks/byEmpresa/${authTokens.Empresa}`);
                const jsnStock = await getStock.json();
                setStock(jsnStock);
                const arr = jsnStock.filter(elR=>elR.Tipo === 'ROUTER');
                const arrCpe = jsnStock.filter(elR=>elR.Tipo === 'CPE');
                const arr_1 = arr.map(el=>el.Modelo);
                const arr_2 = new Set(arr_1);
                const arr_3 = [...arr_2];
                const arr_4 = arrCpe.map(el=>el.Modelo);
                const arr_5 = new Set(arr_4);
                const arr_6 = [...arr_5];
                setOnlyRouters(arr_3);
                setOnlyModelos(arr_6);
            }; handleSearchEl();  
            setArrPhotos(data.FotosReferencia ? data.FotosReferencia.length > 0 ? data.FotosReferencia : [] : []);
            setCreateInstalacion(false);
            setCreateInvoice(false);
            if(data.Coordenadas !== undefined ){
                if(isValidCoordinates(data.Coordenadas)){
                    setCoord(data.Coordenadas)
                }
            }
            var map_ = new mapboxgl.Map({
                container: mapDiv.current,
                style: 'mapbox://styles/mapbox/satellite-v9',
                center: [ 
                    data.Coordenadas === '' ? '-79.93395424851998' : 
                    data.Coordenadas === undefined ? '-79.93395424851998' : 
                    isValidCoordinates(data.Coordenadas) ? 
                    data.Coordenadas.split(',')[1] : '-79.93395424851998', 
                    data.Coordenadas === '' ? '-2.201567808901885' : 
                    data.Coordenadas === undefined ? '-2.201567808901885' : 
                    isValidCoordinates(data.Coordenadas) ? 
                    data.Coordenadas.split(',')[0]  : '-2.201567808901885' ]
                    ,
                zoom: 16.80
            });
    
            const marker = new mapboxgl.Marker();
                marker.id = data._id;
                marker
                    .setLngLat(
                        [ 
                            data.Coordenadas === '' ? '-79.93395424851998' : 
                            data.Coordenadas === undefined ? '-79.93395424851998' : 
                            isValidCoordinates(data.Coordenadas) ? 
                            data.Coordenadas.split(',')[1] : '-79.93395424851998', 
                            data.Coordenadas === '' ? '-2.201567808901885' : 
                            data.Coordenadas === undefined ? '-2.201567808901885' : 
                            isValidCoordinates(data.Coordenadas) ? 
                            data.Coordenadas.split(',')[0]  : '-2.201567808901885' ]
                    )
                    .addTo( map_ )
                    .setDraggable(true)
    
                marker.on('dragend', ({target})=>{
                    setCoord(`${target._lngLat.lat.toString()}, ${target._lngLat.lng.toString()}`);
                })
    
            mapa.current = map_;
        }
    },[]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(continuoInformacionCPE){
            setContinuoInformacionCPE(false);
            setOpenDialogInformacionCPE(true);
        }
    },[continuoInformacionCPE]);

    useEffect(()=>{
        if(isReadyCPE){
            setReadyCPE(false);
            setOpenStatusCPE(true);
        }
    },[isReadyCPE]);

    useEffect(()=>{
        if(isReadyInterfaces){
            setReadyInterfaces(false);
            setOpenInterfaces(true);
        }
    },[isReadyInterfaces]); 

    const handleDatos = ({target})=>{ 
        if(target.id === 'Direccion' || target.id ==='Referencia' || target.id === 'Canton' || target.id === 'Provincia' || target.id === 'Parroquia' || target.id === 'Ciudad'){
            setDatosD({...DatosD, [target.id]:target.value.toUpperCase()}) 
        }else{
            setDatosD({...DatosD, [target.id]:target.value}) 
        }
        
    };

    const handleTipoPago = ({target})=>{
        if(target.checked){
            setDatosD({...DatosD, TipoPago:'PrePago', TipoPagoBoolean:target.checked});
        }else{
            setDatosD({...DatosD, TipoPago:'PostPago', TipoPagoBoolean:target.checked});
        }
    };

    const handleCorteAutomatico = ({target})=>{ setDatosD({...DatosD, CorteAutomatico:target.checked}) };

    const handleDeleteServicio = ()=>{
        if(statusServicioAdd){
            swal({
                title: "Desea Eliminar este Servicio?",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
            .then((value) => {
                if(value){
                    handleBorrarServicio(data);
                }
            });
        }else{
            const objetoDele = {}
            const objetoZ = [...dataCliente.Zonas];
            const indexZ = objetoZ.indexOf(DatosD.ZonaService);
            const objetoZ_ = objetoZ.filter((el,index)=> index !== indexZ);
            objetoDele.Zonas = objetoZ_;
            objetoDele._id = DatosD._id;
            objetoDele.idCliente = dataCliente._id;
            objetoDele.idUiid = data.idUiid;
            objetoDele.idFromMikrotik = DatosD.idFromMikrotik;
            objetoDele.idFromMikrotikSimple = DatosD.idFromMikrotikSimple ? DatosD.idFromMikrotikSimple : '';
            objetoDele.InfoZona = zonaSelected;
            objetoDele.TipoServicioMk = DatosD.TipoServicioMk;
            objetoDele.idForMikrotik = DatosD.idForMikrotik;
            objetoDele.AddressIp = DatosD.AddressIp;
            objetoDele.MacOnu = DatosD.MacOnu;
            objetoDele.MacRouter = DatosD.MacRouter;
            objetoDele.FOptica = false;
            objetoDele.ZonaCliente = DatosD.ZonaService;
            swal({
                title: "Desea Eliminar este Servicio?",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((value)=>{
                if(value){
                    fetch('/api/clientes/servicios',{
                        method:'DELETE',
                        body: JSON.stringify(objetoDele),
                        headers:{
                            'Content-Type': 'application/json'
                        }
                    }) 
                    .then(response=> response.json())
                    .then(result =>{
                        
                        if(result.message){
                            handleBorrarServicioMongo(data);
                            enqueueSnackbar('SERVICIO ELIMINADO',{variant:'success'});    
                        }else{
                            if(result.status === "Error, no such item (4)"){
                                swal({
                                    title: "No existe este Servicio en el Mikrotik, desea proceder con la eliminacion",
                                    icon: "warning",
                                    buttons: true,
                                    dangerMode: true,
                                })
                                .then((value) => {
                                    if(value){
                                        objetoDele.InfoZona.AddClientMikrotik = false;
                                        fetch('/api/clientes/servicios',{
                                            method:'DELETE',
                                            body: JSON.stringify(objetoDele),
                                            headers:{
                                                'Content-Type': 'application/json'
                                            }
                                        }) 
                                        .then(response=> response.json())
                                        .then(result =>{
                                            
                                            if(result.message){
                                                handleBorrarServicio(data.idUiid);
                                            }else{
                                                enqueueSnackbar(`Error ${result.status}`,{variant:'error'});
                                            }
                                        })
                                    }
                                });
                            }else{
                                enqueueSnackbar(`Error ${result.status}`,{variant:'error'});
                            }
                            
                        }
                    });
                }
            })
            
        }
        
    };

    const handleAlertSaveServicio = ()=>{
        setSaving(true);
        swal({
            title: "Desea Guardar este Servicio?",
            icon: "info",
            buttons: true,
        })
        .then((value) => {
            if(value){
                if(data.Status === 'Suspendido'){
                    handleSubSaveServicio(false);
                }else{ 
                    handleValidacion();
                }
            }else{
                setTimeout(()=>{
                    setSaving(false);
                },500)
            }
        });
        
    };

    const handleValidacion = ()=>{
        if(DatosD.Instalacion === '' && !DatosD.isFree){
            enqueueSnackbar('Ingrese Fecha de Instalacion',{variant:'error'});
            setSaving(false);
        }else if(DatosD.AddressIp === ''){
            enqueueSnackbar('Ingrese Direccion IP',{variant:'error'});
            setSaving(false);
        }else if(DatosD.Plan === ''){
            enqueueSnackbar('Seleccione un Plan',{variant:'error'});
            setSaving(false);
        }else if(DatosD.ValorInstalacion === '' && !DatosD.isFree){
            enqueueSnackbar('Valor Instalacion',{variant:'error'});
            setSaving(false);
        }else if(DatosD.DiasCorte === '' && !DatosD.isFree){
            enqueueSnackbar('Ingrese los Dias de Corte',{variant:'error'});
            setSaving(false);
        }else if(DatosD.DiaNotificacion === '' && !DatosD.isFree){
            enqueueSnackbar('Ingrese Dia de Notificacion',{variant:'error'});
            setSaving(false);
        }else if(data.isNew && DatosD.MacRouter === '' && !DatosD.isFree){
            enqueueSnackbar('Seleccione Una Mac Router',{variant:'error'});
            setSaving(false);
        }else if(data.isNew && DatosD.MacModelo === '' && !DatosD.isFree){
            enqueueSnackbar('Seleccione Una Mac CPE',{variant:'error'});
            setSaving(false);            
        }else if(zonaSelected.AddClientMikrotik && DatosD.idForMikrotik === ''){
            enqueueSnackbar('Ingrese id For Mikrotik',{variant:'error'});
            setSaving(false);
        }else{            
            handleValidateMac();
        }
    };

    const handleValidateMac = ()=>{
        if(DatosD.isFree){
            handleSubSaveServicio(true);
        }else{
        if(DatosD.MacModelo === getInfoBackup.MacModelo){
            if(DatosD.MacRouter === getInfoBackup.MacRouter){
                handleSubSaveServicio(false);
            }else{
                handleSubSaveServicio(true);
            } 
        }else{
            handleSubSaveServicio(true);    
        }}
    };

    const handleSubSaveServicio = (valiMac)=>{
        let objeto = {...DatosD};
        let objetoZona = {...zonaSelected};
        const objeto_ = {...getInfoBackup};
        const objetoZ = [...dataCliente.Zonas];
        objetoZ.push(zonaSelected.Zona);
        objetoZona.AddClientMikrotik = getAddClientMikrotik;
        objetoZona.Planes = zonaSelected.planLocal ? zonaSelected.Planes : getPlanes;
        objeto.idCliente = dataCliente._id;
        objeto.Correo = dataCliente.Correo.map(elCorreo=> elCorreo.correo);
        objeto.InfoZona = objetoZona;
        objeto.Vendedor = authTokens.Nombres;
        objeto.data = dataCliente;
        objeto.CI = dataCliente.CI;
        objeto.sendCorreo = DatosD.isFree ? false : isNotificacion;
        objeto.Nombres = `${dataCliente.Nombres} || ${DatosD.idForMikrotik}`;
        objeto.Nombres2 = dataCliente.Nombres;
        objeto.isChangeMac = valiMac;
        objeto.MacModelo_New = DatosD.MacModelo;
        objeto.MacModelo_Back = objeto_.MacModelo;
        objeto.MacRouter_New = DatosD.MacRouter;
        objeto.MacRouter_Back = objeto_.MacRouter;
        objeto.AvanceInstalacion = getAvance;
        objeto.FotosReferencia = getArrPhotos;
        objeto.Coordenadas = getCoord;
        objeto.Zonas = objetoZ;
        objeto.TipoPago = objeto.TipoPagoBoolean ? 'PrePago' : 'PostPago';
        objeto.isIp = true;
        objeto.Empresa = authTokens.Empresa;
        objeto.isCreateInvoice = DatosD.isFree ? false : isCreateInvoice;
        objeto.isCreateInstalacion = DatosD.isFree ? false : isCreateInstalacion;
        objeto.isUnify = isUnify;
        if(statusServicioAdd){
            objeto.isNew = true;
            fetch('/api/clientes/servicios',{
                method:'POST',
                body: JSON.stringify(objeto),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(result =>{
                if(result._id){
                    setStatusServicioAdd(false);
                    handlePostServicio(result);
                    setDatosD({...DatosD, 
                        _id:result._id, 
                        Registro:result.Registro, 
                        isNew:false, 
                        idFromMikrotik:result.idFromMikrotik, 
                        idFromMikrotikSimple:result.idFromMikrotikSimple, 
                        TipoServicioMk:result.TipoServicioMk });             
                    const objeto2 = {...DatosD};
                        objeto2._id = result._id;
                        objeto2.Registro = result.Registro;
                        objeto2.idFromMikrotik = result.idFromMikrotik;
                        objeto2.idFromMikrotikSimple = result.idFromMikrotikSimple;
                        objeto2.TipoServicioMk = result.TipoServicioMk;            
                    enqueueSnackbar('SERVICIO GUARDADO',{variant:'success'});                        
                    setSaving(false);
                    setInfoBackup(objeto2); 
                }else{                
                    enqueueSnackbar(`Error ${result.status}`,{variant:'error'});    
                    setSaving(false);
                }
            });
        }else{
            objeto.isNew = false;
            fetch('/api/clientes/servicios',{
                method:'PUT',
                body: JSON.stringify(objeto),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(result =>{
                if(result.message){
                    handlePutServicio(result);
                    enqueueSnackbar('SERVICIO EDITADO',{variant:'success'});    
                    setSaving(false);
                    setInfoBackup(DatosD); 
                }else{
                    enqueueSnackbar(`Error ${result.status}`,{variant:'error'});    
                    setSaving(false);
                }
               
            });
        }
    };

    const handleStatusIns = ({target})=>{ setDatosD({...DatosD, StatusIns:target.checked}) };

    const handleNotificacion = ({target})=>{ setNotificacion(target.checked);};

    const handleDatosIdMikrotik = ({target})=>{ setDatosD({...DatosD, idForMikrotik:target.value, UserPPOE:target.value}); };

    const handlePlanes = (e,value)=>{
        if(value === null || value === ''){
            setDatosD({...DatosD, Plan:'', ValPlan:0, PlanComercial:''});
        }else{
            const selectPlan = Planes.filter(el=>el.PlanComercial ===  value);
            if(selectPlan.length > 0) setDatosD({...DatosD, PlanComercial:value, ValPlan:selectPlan[0].Valor, Plan:selectPlan[0].Plan});
        }        
    };

    const handleCreatePdf = ()=>{ setReadyPdf(true); };

    const handleClickPdf = useCallback(()=>{
        setTimeout(()=>{
            setReadyPdf(false);
        },[2000]);
    },[]);

    const handleDatosSelect = ({target})=>{ 
        const filterTecnico = getTecnicos.find(el=> el.NombresReducidos === target.value);
        setDatosD({...DatosD, TecnicoAsignado:target.value, TecnicoNombresCompletos:filterTecnico.Nombres});
    };

    const handleCuentasSelect = ({target})=>{ setDatosD({...DatosD, TipoCuenta:target.value}) };

    const handleDatosInstalacion = (e)=>{ setDatosD({...DatosD, Instalacion:e.target.value});};

    const handleModelos = (e, value, reason)=>{
        if(reason === 'select-option'){
            setDatosD({...DatosD, Modelo:value, MacModelo:'' });
            const arr = stock.filter(elStock=> elStock.Modelo === value);
            const arr1 = arr.filter(elStock=> elStock.Mac !== null && elStock.Mac !== undefined && elStock.Mac !== '');
            setMacsModelosArr(arr1.filter(el=>el.Status === 'Disponible'));
        }else{
            setDatosD({...DatosD, Modelo:'', MacModelo:''})
            setMacsModelosArr([]);
        }
    };

    const handleRouters = (e, value, reason)=>{
        if(reason === 'select-option'){
            const filterEq = getEquiposAll.find(el =>el.Modelo === value);
            const arr = stock.filter(elStock=> elStock.Modelo === value);
            setDatosD({...DatosD, Router:value, MacRouter:'', RouterNSerie:'', RouterMarca: filterEq?.Marca | '' });
            const arr1 = arr.filter(elStock=> elStock.Mac !== null && elStock.Mac !== undefined && elStock.Mac !== '');
            setMacsRouters(arr1.filter(el=>el.Status === 'Disponible'));
        }else{
            setDatosD({...DatosD, Router:'', MacRouter:'', RouterNSerie:''})
            setMacsRouters([]);
        }
    };

    const handleSelectMacRouter = (e, value, reason)=>{
        if(value !== ''){
            setDatosD({...DatosD, MacRouter:value });
        }else{
            setDatosD({...DatosD, MacRouter:'' });
        }
    };

    const handleSelectMacModelo = (e, value, reason)=>{
        if(value !== ''){
            setDatosD({...DatosD, MacModelo:value });
        }else{
            setDatosD({...DatosD, MacModelo:'' });
        }
    };

    const handleChangeAutomatic = ()=>{
            const zonaSplit = zonaSelected.Zona.split(' ');
            const idM = `intercomy${zonaSplit[0].toString().charAt(0).toLowerCase()}${zonaSplit.length > 1 ? zonaSplit[1].toString().charAt(0).toLowerCase() : 1 }${ Math.floor(Math.random() * 1000000)}`;
            if(getArrIdForMikrotik.includes(idM)){
                alert('ID GENERADO YA EXISTE, VUELVA A CLICKEAR EL CHECK');
            }else{
                setDatosD({...DatosD, idForMikrotik:idM})
            }     
    };

    const handleAddressIp = ({target})=>{ 
        const elementoIp = getArrIpService.filter(el=> el.IP.toString() === target.value.toString())[0];
        if(isUnify){
            if(zonaSelected.sysintercom){
                setDatosD({...DatosD, AddressIp:target.value, idFromMikrotik:elementoIp.idFromMikrotik, idFromMikrotikSimple:elementoIp.idFromMikrotikSimple});
            }else{
                setDatosD({...DatosD, AddressIp:target.value, idFromMikrotik:elementoIp.idFromMikrotik });
            }
        }else{
            if(elementoIp.Status === 'DISPONIBLE' ){
                const arrIp = [...getArrIpService];
                const arrNew = arrIp.map(el=>{
                    if(el.IP === target.value){
                        const objeto = {};
                        objeto.idForMikrotik = DatosD.idForMikrotik;
                        objeto.Status = 'NO DISPONIBLE';
                        objeto.IP = target.value;
                        return objeto;
                    }else{
                        if(DatosD.AddressIp !== ''){
                            if(el.IP === DatosD.AddressIp){
                                const objeto2 = {};
                                objeto2.Status = 'DISPONIBLE';
                                objeto2.IP = DatosD.AddressIp;
                                return objeto2;
                            }else{
                                return el
                            }
                        }else{
                            return el
                        }
                    }
                });
                setArrIpService(arrNew);
                setDatosD({...DatosD, AddressIp:target.value}) 
            }else{
                Swal.fire({
                    title:'IP NO DISPONIBLE',
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
            }
        }
    };

    const handleSelectSubnet = (e, value, reason)=>{
        if(reason === 'select-option'){
            const elSubnet = zonaSelected.Subnet.filter(el=>el.Red === value)[0];  
            setDatosD({...DatosD, Red:value, Mascara:elSubnet.Mascara}); 
            const arr = [];
            for(const x in getArrIp){
                let redIp = getArrIp[x].IP.split('.');
                let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                if(red === value) arr.push(getArrIp[x]);
            };
            setArrIpService(arr);
        }else{
            if(isUnify){
                setDatosD({...DatosD, Red:'', Mascara:'', AddresIp:'', idFromMikrotik:'', idFromMikrotikSimple:''}); 
                setArrIpService([]);
            }else{
                setDatosD({...DatosD, Red:'', Mascara:'', AddresIp:''}); 
                setArrIpService([]);
            }
        }
        
    };

    const handleAddressIpIptv = ({target})=>{ 
        const elementoIp = getArrIpServiceIptv.filter(el=> el.IP.toString() === target.value.toString())[0];
        if(elementoIp.Status === 'DISPONIBLE' ){
            const arrIp = [...getArrIpServiceIptv];
            const arrNew = arrIp.map(el=>{
                if(el.IP === target.value){
                    const objeto = {};
                    objeto.idForMikrotik = DatosD.idForMikrotik;
                    objeto.Status = 'NO DISPONIBLE';
                    objeto.IP = target.value;
                    return objeto;
                }else{
                    if(DatosD.AddressIp !== ''){
                        if(el.IP === DatosD.AddressIp){
                            const objeto2 = {};
                            objeto2.Status = 'DISPONIBLE';
                            objeto2.IP = DatosD.AddressIp;
                            return objeto2;
                        }else{
                            return el
                        }
                    }else{
                        return el
                    }
                }
            });
            setArrIpServiceIptv(arrNew);
            setDatosD({...DatosD, AddressIpIptv:target.value}) 
        }else{
            Swal.fire({
                title:'IP NO DISPONIBLE',
                icon:'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                toast:true,
            })
        }
        
    };

    const handleSelectSubnetIptv = (e, value, reason)=>{
        if(reason === 'select-option'){
            const elSubnet = zonaSelected.SubnetIptv.filter(el=>el.Red === value)[0];  
            setDatosD({...DatosD, RedIptv:value, MascaraIptv:elSubnet.Mascara}); 
            const arr = [];
            for(const x in getArrIpIptv){
                let redIp = getArrIpIptv[x].IP.split('.');
                let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                if(red === value) arr.push(getArrIp[x]);
            };
            setArrIpServiceIptv(arr);
        }else{
            setDatosD({...DatosD, RedIptv:'', MascaraIptv:''}); 
            setArrIpServiceIptv([]);
        }
        
    };

    const handleOpenPhoto = ()=>{ setOpenPhoto(true) };

    const handleClosePhoto = ()=>{ setOpenPhoto(false) };

    const handleUpdatePhoto = useCallback((info)=>{ setArrPhotos(info); },[]);

    const handleDeletePhoto = useCallback((info)=>{ setArrPhotos((arrPhotos)=> arrPhotos.filter(el=>el.id !== info.id)); },[]);

    const handleAddPhoto = ()=>{
        if(DatosD.idForMikrotik === ''){
            Swal.fire({
                title:'ERROR',
                icon:'error',
                text:'Primero debe asignar un idForMikrotik',
                width:600,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                confirmButtonText:'OK',
                toast:true
            })
        }else{ 
            const arr = [...getArrPhotos];
            const objeto = {};
            objeto.src = '';
            objeto.id = `photo_${uuidv4()}`;
            objeto.idForMikrotik = DatosD.idForMikrotik;
            arr.push(objeto);
            setArrPhotos(arr);
        }
    };

    const handleCoordenadas = ()=>{
        var options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        function success(pos) {
            var crd = pos.coords;    
            //setCoordenadas({Latitud:crd.latitude, Longitud:crd.longitude});  
            setCoord(`${crd.latitude}, ${crd.longitude}`);  
            //setFormulario({...formulario, Latitud:crd.latitude, Longitud:crd.longitude});
        };
          
        function error(err) {
            console.warn('ERROR(' + err.code + '): ' + err.message);
        };

        navigator.geolocation.getCurrentPosition(success, error, options);
    };

    const handleIVA = ({target})=>{ setDatosD({...DatosD, IVA:target.checked}) };

    const copyToClipBoardUser = ()=>{  
        copy(DatosD.idForMikrotik) 
        enqueueSnackbar('Copiado', {variant:'success'});
    };

    const handleInfoBackup = ()=>{
        Swal.fire({
            title:'DESEA VOLVER A CARGAR LA INFORMACION ORIGINAL?',
            icon:'info',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonColor:'#005596',
            width:600,
            confirmButtonText:'SI',
            denyButtonText:'NO'
        }).then((result)=>{
            if(result.isConfirmed){
                setDatosD(getInfoBackup);
            }
        })
    };

    const handleDstPort8880 =()=>{
        setDstPort(true);
        const objeto = {};
        objeto.IPUSUARIO = DatosD.AddressIp;
        objeto.USERMK = DatosD.UserMk;
        objeto.PASSMK = DatosD.PassMk;
        fetch('/api/MikrotikDstNatPort8880',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            // console.log(result)
            setDstPort(false);;
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
            } 
        });
    };

    const handleInformacionCPE = ()=>{
        const filterAp = getArrAp.filter(el=> el.SSID === DatosD.AP);
        // console.log(filterAp)
        if(filterAp.length > 0 ){
            const rowInfo = filterAp[0];
            if(rowInfo.isLocal){ 
                setInfoCharging(true);
                fetch('api/mikrotik/ap/cpe',{
                    method:'POST',
                    body: JSON.stringify(rowInfo),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    // console.log(result)
                    if(result.status){
                        Swal.fire({
                            title:result.status,
                            icon:'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596',
                            toast:true,
                        })
                        setInfoCharging(false);
                    }else{
                        const arr = []
                        result.forEach(value2=>{
                            const objeto = {};
                            //// console.log(value2)
                            for(const x of value2){
                                const splitKey = x.field.split('-');
                                switch(splitKey.length){
                                    case 1: 
                                        objeto[x.field] = x.value; 
                                        break;
                                    case 2: 
                                        let x2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                                        objeto[x2] = x.value; 
                                        break;
                                    case 3: 
                                        let x3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                                        objeto[x3] = x.value; 
                                        break;
                                    case 4: 
                                        let x4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                                        objeto[x4] = x.value; 
                                        break;
                                    default:
                                        objeto[x.field] = x.value; 
                                        break;
                                }
                            };
                            arr.push(objeto);
                        });
                        // console.log(arr);
                        setInformacionAPCPE(arr);
                        setContinuoInformacionCPE(true);
                        setInfoCharging(false);
                    }
                }); 
            }else{
                Swal.fire({
                    title:'Informacion No Disponible',
                    icon:'info',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
            }
        }else{
            enqueueSnackbar('NO EXISTE ESTE AP', {variant:'error'})
        }  
    };

    const handleVerificarCPE = ()=>{
        const filterAp = getArrAp.filter(el=> el.SSID === DatosD.AP);
        if(filterAp.length > 0 ){
            const rowInfo = filterAp[0];
            if(rowInfo.isLocal){ 
                setInfoCharging(true);
                fetch('api/mikrotik/ap/cpe',{
                    method:'POST',
                    body: JSON.stringify(rowInfo),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    setInfoCharging(false);
                    //console.error(result)
                    if(result.status){
                        Swal.fire({
                            title:result.status,
                            icon:'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596',
                            toast:true,
                        })

                    }else{
                        const arr = [];
                        for(const u in result){
                            const objeto = {};
                            for(const x of result[u]){
                                const splitKey = x.field.split('-');
                                switch(splitKey.length){
                                    case 1: 
                                        objeto[x.field] = x.value; 
                                        break;
                                    case 2: 
                                        let x2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                                        objeto[x2] = x.value; 
                                        break;
                                    case 3: 
                                        let x3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                                        objeto[x3] = x.value; 
                                        break;
                                    case 4: 
                                        let x4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                                        objeto[x4] = x.value; 
                                        break;
                                    default:
                                        objeto[x.field] = x.value; 
                                        break;
                                }
                            };
                            arr.push(objeto);
                        }
                        const arrMap = arr.map(el=> el.lastIp);
                        if(arrMap.length > 0){
                            const arrFilterCpe = arrMap.filter(el=> el === DatosD.AddressIp);
                            if(arrFilterCpe.length > 0){
                                Swal.fire({
                                    title:'SI EXISTE CONEXION ENTRE AP Y CPE',
                                    icon:'success',
                                    showDenyButton: false,
                                    showCancelButton: false,
                                    confirmButtonColor:'#005596',
                                    toast:true,
                                });
                            }else{
                                Swal.fire({
                                    title:'NO EXISTE CONEXION ENTRE AP Y CPE',
                                    icon:'error',
                                    showDenyButton: false,
                                    showCancelButton: false,
                                    confirmButtonColor:'#005596',
                                    toast:true,
                                });
                            }
                        }else{
                            Swal.fire({
                                title:'NO EXISTE CONEXION ENTRE AP Y CPE',
                                icon:'error',
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonColor:'#005596',
                                toast:true,
                            });
                        }
                    }
                }); 
            }else{
                Swal.fire({
                    title:'Informacion No Disponible',
                    icon:'info',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
            }
        }else{
            enqueueSnackbar('NO EXISTE ESTE AP', {variant:'error'})
        } 
    };

    const handleStatusCPE = ()=>{
        setInfoCharging2(true);
        const objeto = {};
        objeto.IPUSUARIO = DatosD.AddressIp;
        objeto.USERMK = DatosD.UserMk;
        objeto.PASSMK = DatosD.PassMk;
        fetch('api/mikrotik/StatusCPE',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            setInfoCharging2(false);
            // console.log(result);
            if(result.status){
                enqueueSnackbar(result.status,{variant:'error'});               
            }else{
                setInfoCPE(result[0]);
                setReadyCPE(true);
            }
        });   
    };

    const handleInterfaces = ()=>{
        setInterfacesCharging(true);
        const objeto = {};
        objeto.IPUSUARIO = DatosD.AddressIp;
        objeto.USERMK = DatosD.UserMk;
        objeto.PASSMK = DatosD.PassMk;
        fetch('api/mikrotik/InterfacesCPE',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            // console.log(result)
            setInterfacesCharging(false);
            if(result.status){
                enqueueSnackbar(result.status, {variant:'error'});
            }else{
                const objeto = {};
                    objeto.Status = result[0].running === 'true' ? 'online' : 'offline';
                    objeto.UltimaDesconexion = result[0]['last-link-up-time'];
                    objeto.MacWlan = result[1]['mac-address'];
                    objeto.MacLan = result[0]['mac-address'];
                    objeto.MacRouter = result.length === 3 ? 'offline' : result[2]['mac-address'] ? result[2]['mac-address'] : 'offline';
                    objeto.isStatic = result.length === 3 ? 'offline' : result[2].dynamic === "true" ? 'NO' : 'SI';
                setInterfaces(objeto);
                setReadyInterfaces(true);
            }
            
            
            
        });   
    };

    const handleRebootCPE = ()=>{
        setRebootCPE(true);
        const objeto = {};
        objeto.IPUSUARIO = DatosD.AddressIp;
        objeto.USERMK = DatosD.UserMk;
        objeto.PASSMK = DatosD.PassMk;
        fetch('api/mikrotik/RebootCPE',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setRebootCPE(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setRebootCPE(false);
                },500)
            } 
        });   
    };

    const handleAlertCloseCPE = ()=>{ setOpenDialogInformacionCPE(false); };

    const handleCloseInfoCPE = ()=>{ setOpenStatusCPE(false); };

    const handleCloseInterfaces = ()=>{ setOpenInterfaces(false); };

    const handleSyncMikrotikNew = ()=>{
        setSincronizando(true);
        const filterAp = getArrAp.filter(el=> el.SSID === DatosD.AP);
        if(filterAp.length > 0 ){
            const objeto = {};
                objeto.INFOAP = filterAp[0];
                objeto.NOMBRES = `${dataCliente.Nombres} || ${DatosD.idForMikrotik}`;
                objeto.IPUSUARIO = DatosD.AddressIp;
                objeto.USERMK = DatosD.UserMk;
                objeto.PASSMK = DatosD.PassMk;
                objeto.ISNEW = true;
            fetch('/api/Mikrotik/syncMikrotikNew',{
                method:'POST',
                body: JSON.stringify(objeto),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(resultSync =>{
                setSincronizando(false);
                //console.error(resultSync)
                if(resultSync.message){
                    enqueueSnackbar(resultSync.message, {variant:'success'});
                }else{
                    enqueueSnackbar(resultSync.status, {variant:'error'});
                }     
            })

        }else{
            enqueueSnackbar('NO EXISTE ESTE AP', {variant:'error'});
        }
        
    };

    const handleSyncMikrotik = ()=>{
        setSincronizando2(true);
        const filterAp = getArrAp.filter(el=> el.SSID === DatosD.AP);
        if(filterAp.length > 0 ){
            const objeto = {};
                objeto.INFOAP = filterAp[0];
                objeto.NOMBRES = `${dataCliente.Nombres} || ${DatosD.idForMikrotik}`;
                objeto.IPUSUARIO = DatosD.AddressIp;
                objeto.USERMK = DatosD.UserMk;
                objeto.PASSMK = DatosD.PassMk;
                objeto.ISNEW = false;
            fetch('/api/Mikrotik/syncMikrotikNew',{
                method:'POST',
                body: JSON.stringify(objeto),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(resultSync =>{
                setSincronizando2(false);
                //console.error(resultSync);
                if(resultSync.message){
                    enqueueSnackbar(resultSync.message, {variant:'success'});
                }else{
                    enqueueSnackbar(resultSync.status, {variant:'error'});
                }
            });
        }else{
            enqueueSnackbar('NO EXISTE ESTE AP', {variant:'error'});         
        }     
    };

    const copyMacRouter = ()=>{
        copy(getInterfaces.MacRouter) 
        enqueueSnackbar('Copiado', {variant:'success'});
    };

    const copyMacWlan = ()=>{
        copy(getInterfaces.MacWlan) 
        enqueueSnackbar('Copiado', {variant:'success'});
    };

    const copyMacLan = ()=>{
        copy(getInterfaces.MacLan) 
        enqueueSnackbar('Copiado', {variant:'success'});
    };

    const handleCloseComandos = ()=> { setOpenComandos(false); }

    const handleOpenComandos = ()=> { setOpenComandos(true); }

    const handleRemoveArp = ()=>{
        setRemovingArp(true);
        const objeto = {};
        objeto.IPUSUARIO = DatosD.AddressIp;
        objeto.USERMK = DatosD.UserMk;
        objeto.PASSMK = DatosD.PassMk;
        fetch('api/mikrotik/RemoveArp',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setRemovingArp(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setRemovingArp(false);
                },500)
            } 
        });
    };

    const handlePassCPE = ()=>{
        setPassCPE(true);
        const objeto = {};
        objeto.IPUSUARIO = DatosD.AddressIp;
        objeto.USERMK = DatosD.UserMk;
        objeto.PASSMK = DatosD.PassMk;
        objeto.ISNEW = true;
        fetch('api/mikrotik/SetPassCPE',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setPassCPE(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setPassCPE(false);
                },500)
            } 
        });
    };

    const handleInfoWlan = ()=>{
        setInfoWlan(true);
        const objeto = {};
        objeto.IPUSUARIO = DatosD.AddressIp;
        objeto.USERMK = DatosD.UserMk;
        objeto.PASSMK = DatosD.PassMk;
        objeto.ISNEW = true;
        fetch('api/mikrotik/SetInfoWlan',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setInfoWlan(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setInfoWlan(false);
                },500)
            } 
        });
    };

    const handleSubNetWatch = async ({target})=>{
        if(target.checked){
            const isActiveN = await handleNetWatch({
                AddressIp:DatosD.AddressIp, 
                ActiveNetWatch:true, 
                InfoZona:zonaSelected,
                idForMikrotik:data.idForMikrotik,
                Nombres:dataCliente.Nombres,
                idServicio:DatosD._id,
                idCliente:dataCliente._id,
            });

            if(isActiveN.isCreate){
                setDatosD({...DatosD, idNetWatch:isActiveN.idNetWatch, ActiveNetWatch:true})
                enqueueSnackbar('CLIENTE VIGILADO', {variant:'success'});
            }else{
                enqueueSnackbar(isActiveN.reason, {variant:'error'});
            }

            
            
        }else{
            const isActiveN = await handleNetWatch({
                ActiveNetWatch:false, 
                InfoZona:zonaSelected,
                idNetWatch:DatosD.idNetWatch,
                idServicio:DatosD._id,
                idCliente:dataCliente._id,
            });
            
            if(isActiveN.isCreate){
                enqueueSnackbar('CLIENTE SIN VIGILAR', {variant:'success'});
                setDatosD({...DatosD, idNetWatch:'', ActiveNetWatch:false})
            }else{
                enqueueSnackbar(isActiveN.reason, {variant:'error'});
            }
        }
        
    };

    const copyAddressIp = ()=>{
        copy(DatosD.AddressIp);
        enqueueSnackbar('Copiado', {variant:'success'});
    };

    const handleBlurCoord = ({target})=>{
        if(target.value !== ''){
            if (!target.value.match(/^[-]?\d+[.]?\d*, [-]?\d+[.]?\d*$/)) {
                alert('COORDENADAS ERRONEAS')
            }
        }
    };

    const handlePingOnu = ()=>{
        setSearchingPingOnu(true)
        fetch('/api/pingOnu',{
            method:'POST',
            body: JSON.stringify({AddressIp:DatosD.AddressIp}),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                Swal.fire({
                    title:result.message,
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
                setTimeout(()=>{
                    setSearchingPingOnu(false);
                },500)
            }else{
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setTimeout(()=>{
                    setSearchingPingOnu(false);
                },500)
            } 
        }); 
    };

    const handleUnify = ({target})=>{
        if(data.isNew){
            setUnify(target.checked);
        }else{
            if(isUnify){
                setUnify(false);
                setDatosD({...DatosD, idFromMikrotik:getInfoBackup.idFromMikrotik, AddressIp:getInfoBackup.AddressIp});
            }else{
                setUnify(target.checked);
            }
        }
    };

    const handleServActive = (checked)=>{
        setOfflineServ(true)
        fetch('/api/clientes/servicios/changeStatusMk',{
            method:'POST',
            body: JSON.stringify({
                serviceSelected:DatosD,
                InfoZona:zonaSelected,
                Status:checked,
            }),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                Swal.fire({
                    title:'SERVICIO ACTUALIZADO',
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
                setServActive(checked);
                setTimeout(()=>{
                    setOfflineServ(false);
                },500)
            }else{
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setTimeout(()=>{
                    setOfflineServ(false);
                },500)
            } 
        }); 
    };

    const handleMesArcotel = (e, value, reason)=>{
        if(reason === 'select-option'){
            setDatosD({...DatosD, MesArcotel:value });
        }else{
            setDatosD({...DatosD, MesArcotel:'' })
        }
    };

    return(
        <Grid item xs={12}>
            <Dialog
                open={openPhoto}
                onClose={handleClosePhoto}
                fullWidth
                maxWidth={'sm'}
                style={{padding:0}}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClosePhoto}>
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                            <Chip color='secondary' label='FOTOS REFERENCIA' style={{fontWeight:'bolder'}}/>
                        </Grid>
                        <Grid item style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                            <Tooltip title='ADD PHOTO' arrow placement='right'>
                                <span>
                                <IconButton size='medium' onClick={handleAddPhoto} >
                                    <AddCircleIcon color='primary'/>
                                </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent style={{margin:0, padding:5, overflowX:'hidden'}}>
                    <Divider />
                    <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                    <Grid container justifyContent='center' spacing={2}>                   
                    {
                        getArrPhotos.map((infoPhoto, index)=> 
                            <Grid item key={`tiptraphoto_${index}`}>
                                <UploadElementYounet
                                    classes={classes}
                                    handleUpdatePhoto={handleUpdatePhoto}
                                    info={infoPhoto}
                                    handleDeletePhoto={handleDeletePhoto}
                                    idForMikrotik={DatosD.idForMikrotik}
                                    idServicio={DatosD._id}
                                    idCliente={dataCliente._id}
                                    getArrPhotos={getArrPhotos}
                                    enqueueSnackbar={enqueueSnackbar}
                                />
                            </Grid>
                        )
                    }
                    </Grid>
                     </Paper>
                    
                </DialogContent>
            </Dialog> 
            <Dialog
                open={openDialogInformacionCPE}
                onClose={handleAlertCloseCPE}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth='md'
            >
                <DialogTitle id="customized-dialog-title" onClose={handleAlertCloseCPE}>
                    Informacion C.P.E.
                </DialogTitle>
                <DialogContent>
                    <Paper stye={{width:'100%'}}>
                        <TableContainer style={{maxHeight: 440}}>
                            <Table stickyHeader aria-label="simple table" >
                                <TableHead>
                                <TableRow>
                                    <TableCell>CLIENTE</TableCell>
                                    <TableCell>MAC</TableCell>
                                    <TableCell>ULTIMA ACTIVIDAD</TableCell>
                                    <TableCell>CCQ</TableCell>
                                    <TableCell>IP</TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {informacionAPCPE.map((row, index) => (
                                    <TableRow key={`cpe_Info_${index}`}>
                                        <TableCell > {row.radioName}</TableCell>
                                        <TableCell >{row.macAddress}</TableCell>
                                        <TableCell >{row.lastActivity}</TableCell>
                                        <TableCell >{`tx:${row.txCcq} rx:${row.rxCcq}`}</TableCell>
                                        <TableCell >{row.lastIp}</TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </DialogContent>
            </Dialog>
            <ModalAntd title="INFORMACION CONEXION" visible={getOpenStatusCPE} onCancel={handleCloseInfoCPE} okButtonProps={{disabled:true, type:'ghost'}}>
                <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                    <Grid container justifyContent='space-between' spacing={2}> 
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-around' spacing={1}>  
                                <Grid item xs={6}>
                                    <TextField 
                                        id='APCPE'
                                        fullWidth
                                        label='AP'
                                        value={getInfoCPE['radio-name'] || ''}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>                 
                                <Grid item xs={6}>
                                    <TextField 
                                        id='UPTIME'
                                        fullWidth
                                        label='TIEMPO ONLINE'
                                        value={getInfoCPE['uptime'] || ''}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>                            
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-around' spacing={1}>                   
                                <Grid item xs={6}>
                                    <TextField 
                                        id='CCQTX'
                                        fullWidth
                                        label='CCQ TX'
                                        value={getInfoCPE['tx-ccq'] || ''}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField 
                                        id='CCQRX'
                                        fullWidth
                                        label='CCQ RX'
                                        value={getInfoCPE['rx-ccq'] || ''}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>                             
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-around' spacing={1}>                   
                                <Grid item xs={6}>
                                    <TextField 
                                        id='TXSIGNAL'
                                        fullWidth
                                        label='SIGNAL TX'
                                        value={getInfoCPE['tx-signal-strength'] || ''}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField 
                                        id='RXSIGNAL'
                                        fullWidth
                                        label='SIGNAL RX'
                                        value={getInfoCPE['signal-strength'] || ''}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>                               
                            </Grid>
                        </Grid>
                        
                    </Grid>
                </Paper>
            </ModalAntd>
            <ModalAntd title="INFORMACION INTERFACES" visible={getOpenInterfaces} onCancel={handleCloseInterfaces} okButtonProps={{disabled:true, type:'ghost'}}>
                <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                    <Grid container justifyContent='space-between' spacing={2}> 
                        <Grid item xs={6}>
                            <TextField 
                                id='STATUSCPEROUTER'
                                fullWidth
                                label='AP'
                                value={getInterfaces.Status || ''}
                                variant='outlined'
                                size='large'
                                margin='dense'
                            />
                        </Grid>                 
                        <Grid item xs={6}>
                            <TextField 
                                id='LASTUPTIME'
                                fullWidth
                                label='ULTIMA DESCONEXION'
                                value={getInterfaces.UltimaDesconexion || ''}
                                variant='outlined'
                                size='large'
                                margin='dense'
                            />
                        </Grid>      
                        <Grid item xs={6}>
                            <TextField 
                                id='MACWLAN'
                                fullWidth
                                label='MAC WLAN'
                                value={getInterfaces.MacWlan || ''}
                                variant='outlined'
                                size='large'
                                margin='dense'
                                InputProps={{ 
                                    endAdornment:
                                    <IconButton size='small' onClick={copyMacWlan} color='primary'>
                                        <ContentCopyIcon/>
                                    </IconButton>
                                }} 
                            />
                        </Grid>    
                        <Grid item xs={6}>
                            <TextField 
                                id='MACLAN'
                                fullWidth
                                label='MAC LAN'
                                value={getInterfaces.MacLan || ''}
                                variant='outlined'
                                size='large'
                                margin='dense'
                                InputProps={{ 
                                    endAdornment:
                                    <IconButton size='small' onClick={copyMacLan} color='primary'>
                                        <ContentCopyIcon/>
                                    </IconButton>
                                }} 
                            />
                        </Grid>                                    
                        <Grid item xs={6}>
                            <TextField 
                                id='MACROUTER'
                                fullWidth
                                label='MAC ROUTER'
                                value={getInterfaces.MacRouter || ''}
                                variant='outlined'
                                size='large'
                                margin='dense'
                                InputProps={{ 
                                    endAdornment:
                                    <IconButton size='small' onClick={copyMacRouter} color='primary'>
                                        <ContentCopyIcon/>
                                    </IconButton>
                                }} 
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField 
                                id='ISSTATIC'
                                fullWidth
                                label='ES ESTATICO'
                                value={getInterfaces.isStatic || ''}
                                variant='outlined'
                                size='large'
                                margin='dense'
                            />
                        </Grid>                             
                    </Grid>
                </Paper>
            </ModalAntd> 
            <ModalAntd title="COMANDOS MIKROTIK" visible={getOpenComandos} onCancel={handleCloseComandos} okButtonProps={{disabled:true, type:'ghost'}}>
                <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                    <Grid container justifyContent='space-between' spacing={2}> 
                        <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="DST PORT 8880" color='purple' placement='right'>
                                <ButtonAntd style={{backgroundColor:'teal'}} type="primary" icon={isDstPort ? <LoadingOutlinedIcon/> : <RadiusSettingOutlinedIcon />} size='large' onClick={handleDstPort8880}/>
                            </TooltipAntd>
                        </Grid>                 
                        <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="REMOVER ARP" color='purple' placement='left'>
                                <ButtonAntd style={{backgroundColor:'blue'}} type="primary" icon={isRemovingArp ? <LoadingOutlinedIcon/> : <DeleteOutlinedIcon />} size='large' onClick={handleRemoveArp}/>
                            </TooltipAntd>
                        </Grid>                                          
                        <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="ESTABLECER PASS" color='purple' placement='right'>
                                <ButtonAntd style={{backgroundColor:'green'}} type="primary" icon={getPassCPE ? <LoadingOutlinedIcon/> : <VerifiedOutlinedIcon />} size='large' onClick={handlePassCPE}/>
                            </TooltipAntd>
                        </Grid>                 
                        <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="ESTABLECER WLAN" color='purple' placement='left'>
                                <ButtonAntd style={{backgroundColor:'navy'}} type="primary" icon={getInfoWlan ? <LoadingOutlinedIcon/> : <InteractionOutlinedIcon />} size='large' onClick={handleInfoWlan}/>
                            </TooltipAntd>
                        </Grid>
                        <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="CONFIGURAR MIKROTIK NUEVO" color='purple' placement='right'>
                                <Popconfirm
                                    title="Desea Continuar?"
                                    onConfirm={handleSyncMikrotikNew}
                                    okText="SI"
                                    cancelText="NO"
                                >
                                    <ButtonAntd style={{backgroundColor:'orange'}} shape='circle' type="primary" icon={getSincronizando ? <LoadingOutlinedIcon /> : <SyncIcon />} size='large' />
                                </Popconfirm>
                            </TooltipAntd>                     
                        </Grid> 
                        <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="CONFIGURAR MIKROTIK" color='purple' placement='left'>
                                <Popconfirm
                                    title="Desea Continuar?"
                                    onConfirm={handleSyncMikrotik}
                                    okText="SI"
                                    cancelText="NO"
                                >
                                    <ButtonAntd style={{backgroundColor:'green'}} shape='circle' type="primary" icon={getSincronizando2 ? <LoadingOutlinedIcon /> : <SyncIcon />} size='large' />
                                </Popconfirm>
                            </TooltipAntd>                     
                        </Grid>                             
                    </Grid>
                </Paper>
            </ModalAntd> 
            <Paper elevation={3} style={{padding:10}} key={`servicio${index}`}>
                <Grid container  spacing={2} justifyContent='center' >
                    <Grid item xs={12} style={{height:5}}>
                        {!isIpsCharged &&  <LinearProgress color='secondary' /> }
                    </Grid>
                    <Grid item xs={12} style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
                        <Grid container spacing={2} justifyContent='center'>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="NUMERO DE CONTRATO" color='blue' placement='left'>
                                    <Avatar style={{width:40, height:40}} >
                                        { DatosD.NumberServiceClient ? DatosD.NumberServiceClient : 0 }
                                    </Avatar>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center', height:42, alignText:'center',}}>
                                {
                                    DatosD.Status === 'Activo' ?
                                        <TooltipAntd title="SERVICIO ACTIVO" color='green'>
                                            <CheckCircleIcon style={{color:'green', marginTop:15}} fontSize='large'/>
                                        </TooltipAntd>
                                        :
                                        <TooltipAntd title="SERVICIO SUSPENDIDO" color='red'>
                                            <BlockIcon style={{color:'red', marginTop:15}} fontSize='large'/>
                                        </TooltipAntd>
                                }                                       
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="GUARDAR SERVICIO" color='purple'>
                                    <ButtonAntd type="primary" icon={isSaving ? <LoadingOutlinedIcon/> : <SaveOutlinedIcon />} size='large' onClick={handleAlertSaveServicio}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="ELIMINAR SERVICIO" color='purple'>
                                    <ButtonAntd type="danger" icon={<DeleteOutlinedIcon />} size='large' onClick={handleDeleteServicio} disabled={authTokens.Type === 'ADMINISTRADOR' ? false : true}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="BACKUP" color='purple'>
                                    <ButtonAntd type="primary" icon={<ReloadOutlinedIcon />} size='large' onClick={handleInfoBackup}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="PING CPE" color='purple'>
                                    <ButtonAntd style={{background:'black'}} type="primary" icon={isSearchingPingOnu ? <LoadingOutlinedIcon /> : <NodeIndexOutlined />} size='large' onClick={handlePingOnu}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="VERIFICAR CPE EN AP" color='purple'>
                                    <ButtonAntd style={{backgroundColor:'orange'}} type="primary" icon={isInfoCharging ? <LoadingOutlinedIcon/> : <ApiOutlinedIcon />} size='large' onClick={handleVerificarCPE}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="STATUS CPE" color='purple'>
                                    <ButtonAntd style={{backgroundColor:'brown'}} type="primary" icon={isInfoCharging2 ? <LoadingOutlinedIcon/> : <WifiOutlinedIcon />} size='large' onClick={handleStatusCPE}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="INTERFACES CPE" color='purple'>
                                    <ButtonAntd style={{backgroundColor:'green'}} type="primary" icon={isInterfacesCharging ? <LoadingOutlinedIcon/> : <ClusterOutlinedIcon />} size='large' onClick={handleInterfaces} />
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="COMANDOS CPE" color='purple'>
                                    <ButtonAntd style={{backgroundColor:'navy'}} type="primary" icon={<SettingOutlinedIcon />} size='large' onClick={handleOpenComandos} />
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="CLIENTE CON VALORES A PAGAR EN $0" color='purple'>
                                    <CheckboxAntd onChange={({target})=>{setDatosD({...DatosD, isFree:target.checked})}} checked={DatosD.isFree || false}>
                                        <Chip label="FREE" color='secondary' style={{backgroundColor:'#5D6D7E'}}/>
                                    </CheckboxAntd>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="CLIENTE REGISTRADO EN LA ARCOTEL?" color='purple'>
                                    <CheckboxAntd onChange={({target})=>{setDatosD({...DatosD, isArcotel:target.checked})}} checked={DatosD.isArcotel || false}>
                                        <Chip label="ARCOTEL" color='secondary' style={{backgroundColor:'SteelBlue'}}/>
                                    </CheckboxAntd>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="REINICIAR CPE" color='purple' placement='right'>
                                    <Popconfirm
                                        title="DESEA REINICIAR EL CPE?"
                                        onConfirm={handleRebootCPE}
                                        okText="SI"
                                        cancelText="NO"
                                    >
                                        <ButtonAntd style={{backgroundColor:'orange'}} shape='circle' type="primary" icon={isRebootCPE ? <LoadingOutlinedIcon /> : <PoweroffOutlinedIcon />} size='large' />
                                    </Popconfirm>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="CREAR PDF" color='purple'>
                                    <ButtonAntd type="danger" icon={<FilePdfOutlinedIcon />} size='large' onClick={handleCreatePdf}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item >
                                {isReadyPdf && 
                                    <PdfInstalacionRadio 
                                    data={DatosD} 
                                    dataCliente={dataCliente}
                                    dataZona={ zonaSelected }
                                    getPlanes={ zonaSelected.planLocal ? zonaSelected.Planes : getPlanes }
                                    getEquiposAll={ getEquiposAll }
                                    handleClickPdf={handleClickPdf} 
                                    />}
                            </Grid>  
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="EQUIPO DE ULTIMA MILLA PERMITE ACCESO TELNET?" color='purple'>
                                    <SwitchAntd 
                                        checkedChildren='ON TELNET' 
                                        onChange={(checked)=>{setDatosD({...DatosD, isTelnet:checked})}}
                                        unCheckedChildren="OFF TELNET" 
                                        checked={DatosD.isTelnet || false}
                                    />
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <CheckboxAntd onChange={handleIVA} checked={DatosD.IVA}>
                                    <Chip label="IVA" color='secondary'/>
                                </CheckboxAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <CheckboxAntd onChange={handleNotificacion} checked={isNotificacion}>
                                    <Chip label="NOTIFICACION" color='primary' />
                                </CheckboxAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <CheckboxAntd onChange={handleSubNetWatch} checked={DatosD.ActiveNetWatch}>
                                    <Chip label="NETWATCH" color='primary' style={{background:'dodgerBlue'}}/>
                                </CheckboxAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="DESEA CREAR INSTALACION?" color='purple'>
                                    <CheckboxAntd onChange={({target})=>{setCreateInstalacion(target.checked)}} checked={isCreateInstalacion}>
                                        <Chip label="INSTALACION" color='primary' style={{background:'MediumSeaGreen'}}/>
                                    </CheckboxAntd>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="DESEA CREAR FACTURAS?" color='purple'>
                                    <CheckboxAntd onChange={({target})=>{setCreateInvoice(target.checked)}} checked={isCreateInvoice} >
                                        <Chip label="FACTURA" color='primary' style={{background:'crimson'}}/>
                                    </CheckboxAntd>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="UNIFICAR" color='purple'>
                                    <CheckboxAntd onChange={handleUnify} checked={isUnify} >
                                        <Chip label="UNIFICAR" color='primary' style={{background:'#5D6D7E'}}/>
                                    </CheckboxAntd>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="ACTIVAR O SUSPENDER SERVICIO" color='red'>
                                    <SwitchAntd 
                                        checkedChildren='ONLINE' 
                                        onChange={handleServActive}
                                        unCheckedChildren="OFFLINE" 
                                        checked={isServActive || false}
                                    />
                                </TooltipAntd>
                                {isOfflineServ && <LoadingOutlinedIcon />}
                            </Grid>
                        </Grid>                                  
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} >
                        <Grid container spacing={1}>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="GENERAR ID" color='purple'>
                                    <ButtonAntd type="primary" icon={<RedoOutlinedIcon />} size='large' onClick={handleChangeAutomatic}/>
                                </TooltipAntd>
                                
                            </Grid>
                            <Grid item xs={10}>
                                <TextField 
                                    id='idForMikrotik'
                                    fullWidth
                                    label='idMikrotik'
                                    value={DatosD.idForMikrotik || ''}
                                    onChange={handleDatosIdMikrotik}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                    InputProps={{ 
                                        startAdornment: <WhatshotIcon/>, 
                                        endAdornment:
                                        <IconButton size='small' onClick={copyToClipBoardUser} color='primary'>
                                            <ContentCopyIcon/>
                                        </IconButton>
                                    }} 
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <TextField 
                            id='idFromMikrotik'
                            fullWidth
                            label='idFromMikrotik'
                            value={DatosD.idFromMikrotik || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            InputProps={{ startAdornment: <WhatshotIcon/>  }} 
                        />
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} >
                        <TextField 
                            id='CodigoMedidor'
                            fullWidth
                            label='Codigo de Medidor'
                            value={DatosD.CodigoMedidor || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            InputProps={{ startAdornment: <EmojiObjectsIcon/>  }} 
                        />
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} >
                        <Autocomplete
                            id='Plan'                                            
                            options={Planes}
                            getOptionLabel={(option)=>option.PlanComercial}
                            inputValue={DatosD.PlanComercial || ''}
                            onInputChange={handlePlanes}
                            renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <SpeedIcon/>}} 
                            fullWidth label="Plan" variant="outlined" required size='small'margin='dense'
                        />}
                        />
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} >
                        <TextField 
                            id='TipoCuenta'
                            fullWidth
                            label='Tipo de Cuenta'
                            value={ DatosD.TipoCuenta || '' }
                            onChange={handleCuentasSelect}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            select
                        >
                            {
                                getCuentas.map((el,index)=>                                   
                                <MenuItem value={el} key={`Cuenta_${index}_${el}`}>
                                    {el}
                                </MenuItem>
                                )
                            }
                        </TextField>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} >
                        <TextField 
                            id='Provincia'
                            fullWidth
                            label='Provincia'
                            value={DatosD.Provincia || ''}
                            onChange={handleDatos}
                            InputProps={{ startAdornment: <PlaceIcon/> }}
                            variant='outlined'
                            margin='dense'
                            size='small'
                        />
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='Ciudad'
                            fullWidth
                            label='Ciudad'
                            value={DatosD.Ciudad || ''}
                            onChange={handleDatos}
                            InputProps={{ startAdornment: <PlaceIcon/> }}
                            variant='outlined'
                            margin='dense'
                            size='small'
                        />
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='Canton'
                            fullWidth
                            label='Canton'
                            value={DatosD.Canton || ''}
                            onChange={handleDatos}
                            InputProps={{ startAdornment: <PlaceIcon/> }}
                            variant='outlined'
                            margin='dense'
                            size='small'
                        />
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='Parroquia'
                            fullWidth
                            label='Parroquia'
                            value={DatosD.Parroquia || ''}
                            onChange={handleDatos}
                            InputProps={{ startAdornment: <PlaceIcon/> }}
                            variant='outlined'
                            margin='dense'
                            size='small'
                        />
                    </Grid>
                    <Grid item md={6} sm={6} xs={12} >
                        <TextField 
                            id='Direccion'
                            fullWidth
                            label='Direccion'
                            value={DatosD.Direccion || ''}
                            onChange={handleDatos}
                            InputProps={{ startAdornment: <PlaceIcon/> }}
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid> 
                    <Grid item md={6} sm={6} xs={12} >
                        <TextField 
                            id='Referencia'
                            fullWidth
                            label='Referencia'
                            value={DatosD.Referencia || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            margin='dense'
                            InputProps={{
                                startAdornment: <PlaceIcon/>,
                                endAdornment: 
                                <IconButton aria-label="search" onClick={handleOpenPhoto} size='small'>
                                    <PhotoIcon color='primary' />
                                </IconButton>
                            }}
                            size='small'
                        />
                    </Grid>  
                    <Grid item md={2} sm={6} xs={12} >
                        <Autocomplete
                            id='MesArcotel'       
                            disabled={!DatosD.isArcotel}                                     
                            options={onlyMeses}
                            value={DatosD.MesArcotel || ''}
                            onChange={handleMesArcotel}
                            renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps,
                                startAdornment: <EventIcon/>,
                            }} fullWidth label="Mes Arcotel" variant="outlined" required size='small' margin='dense'/>}
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                        <TextField 
                            id='Coordenadas'
                            fullWidth
                            label='Coordenadas'
                            value={getCoord || ''}
                            onChange={({target})=>setCoord(target.value)}
                            onBlur={handleBlurCoord}
                            variant='outlined'
                            InputProps={{
                                endAdornment: 
                                <IconButton aria-label="search" onClick={handleCoordenadas} size='small'>
                                    <GpsFixedIcon color='primary' />
                                </IconButton>
                            }}
                            size='small'
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                        <Grid container justifyContent='center' spacing={1}>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="INFORMACION CPE" color='purple'>
                                    <ButtonAntd type="primary" icon={isInfoCharging ? <LoadingOutlinedIcon/> : <WifiOutlinedIcon />} size='large' onClick={handleInformacionCPE}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item xs={10}>
                                <Autocomplete
                                    id='AP'                                            
                                    options={getArrAp}
                                    getOptionLabel={(option)=>option.SSID}
                                    inputValue={DatosD.AP || ''}
                                    onInputChange={(e,value)=>setDatosD({...DatosD, AP:value})}
                                    renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <WifiTetheringIcon/>, }} margin='dense' fullWidth label="AP" variant="outlined" required size='small'/>}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                        <Autocomplete
                            id='Modelo'                                            
                            options={onlyModelos}
                            value={DatosD.Modelo || ''}
                            onChange={handleModelos}
                            renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps,
                                startAdornment: <RouterIcon/>,
                            }} fullWidth label="CPE" variant="outlined" required size='small' margin='dense'/>}
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                        <Autocomplete
                            id='MacModelo'                                            
                            options={macsModelosArr}
                            inputValue={DatosD.MacModelo|| ''}
                            onInputChange={handleSelectMacModelo}
                            getOptionLabel={(option) => option.Mac}
                            renderOption={(option) => (
                                <span style={{color: option.Status === 'Disponible' ? 'green' : option.Status === 'No Disponible' ? 'red' : 'orange'}}>{option.Mac}</span>
                            )}
                            renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <RouterIcon/>,}} margin='dense' fullWidth label="Mac CPE" variant="outlined" required size='small'/>}
                        />
                    </Grid>            
                    <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                        <Autocomplete
                            id='Router'                                            
                            options={onlyRouters}
                            value={DatosD.Router || ''}
                            onChange={handleRouters}
                            renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <RouterIcon/>,}} margin='dense' fullWidth label="Router" variant="outlined" required size='small'/>}
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                        <Autocomplete
                            id='MacRouter'                                            
                            options={macsRouters}
                            inputValue={DatosD.MacRouter || ''}
                            onInputChange={handleSelectMacRouter}
                            getOptionLabel={(option) => option.Mac}
                            renderOption={(option) => (
                                <span style={{color: option.Status === 'Disponible' ? 'green' : option.Status === 'No Disponible' ? 'red' : 'orange'}}>{option.Mac}</span>
                            )}
                            renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <RouterIcon/>,}} margin='dense' fullWidth label="Mac Router" variant="outlined" required size='small'/>}
                        />
                    </Grid>
                    {
                        zonaSelected.AddClientMikrotik ?
                        <React.Fragment>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                                <Autocomplete
                                    id='Subnet'                                            
                                    options={zonaSelected.Subnet.map(el=>el.Red)}
                                    value={DatosD.Red || ''}
                                    onChange={handleSelectSubnet}
                                    renderInput={(params) => <TextField {...params} margin='dense' fullWidth label="Subnet" variant="outlined" size='small'/>}
                                />
                            </Grid>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                                <Grid container spacing={1} >
                                    <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                        <TooltipAntd title="ACCEDER AL ROUTER" color='purple'>
                                            <IconButton color="primary"  size='medium'  target="_blank" href={`http://${DatosD.AddressIp}:8880`}>
                                                <ChromeOutlinedIcon />
                                            </IconButton>
                                        </TooltipAntd>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <TextField 
                                            id='AddressIp'
                                            fullWidth
                                            label='IP'
                                            value={DatosD.AddressIp || ''}
                                            InputProps={{ startAdornment:<DnsIcon/> }}
                                            onChange={handleAddressIp}
                                            variant='outlined'
                                            size='small'
                                            margin='dense'
                                            select
                                        >
                                            {
                                                getArrIpService.map((el, index)=>{
                                                    if(el.Status === 'DISPONIBLE'){
                                                        return(
                                                            <MenuItem value={el.IP.toString()} style={{color:'green'}} key={`ip_address_${index}`}>
                                                                {el.IP.toString()}
                                                            </MenuItem>
                                                        )
                                                    }else{
                                                        return(
                                                            <MenuItem value={el.IP.toString()} style={{color:el.Status === 'NO DISPONIBLE' ? 'red': 'orange'}} key={`ip_address_${index}`} >
                                                                { `${el.IP.toString()} ${el.idForMikrotik === null ? '' : el.idForMikrotik}` }
                                                            </MenuItem>
                                                        )
                                                    }
                                                })
                                            }
                                        </TextField>
                                    </Grid>
                                    <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                        <IconButton color="primary"  size='medium'  onClick={copyAddressIp}>
                                            <ContentCopyIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </React.Fragment>:
                        <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                            <TextField 
                                id='AddressIp'
                                fullWidth
                                label='IP'
                                value={DatosD.AddressIp || ''}
                                InputProps={{ startAdornment:<DnsIcon/> }}
                                onChange={handleDatos}
                                variant='outlined'
                                size='small'
                                margin='dense'
                            />
                        </Grid>
                    }   
                    {
                        zonaSelected.isIptv ?
                        <React.Fragment>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                                <Autocomplete
                                    id='SubnetIptv'                                            
                                    options={zonaSelected.SubnetIptv.map(el=>el.Red)}
                                    value={DatosD.RedIptv || ''}
                                    onChange={handleSelectSubnetIptv}
                                    renderInput={(params) => <TextField {...params} margin='dense' fullWidth label="SubnetIptv" variant="outlined" size='small'/>}
                                />
                            </Grid>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                                        <TextField 
                                            id='AddressIpIptv'
                                            fullWidth
                                            label='IP_IPTV'
                                            value={DatosD.AddressIpIptv || ''}
                                            InputProps={{ startAdornment:<DnsIcon/> }}
                                            onChange={handleAddressIpIptv}
                                            variant='outlined'
                                            size='small'
                                            margin='dense'
                                            select
                                        >
                                            {
                                                getArrIpServiceIptv.map((el, index)=>{
                                                    if(el.Status === 'DISPONIBLE'){
                                                        return(
                                                            <MenuItem value={el.IP.toString()} style={{color:'green'}} key={`IP_Address_${index}`}>
                                                                {el.IP.toString()}
                                                            </MenuItem>
                                                        )
                                                    }else{
                                                        return(
                                                            <MenuItem value={el.IP.toString()} style={{color:el.Status === 'NO DISPONIBLE' ? 'red': 'orange'}} key={`IP_Address_${index}`} >
                                                                { `${el.IP.toString()} ${el.idForMikrotik === null ? '' : el.idForMikrotik}` }
                                                            </MenuItem>
                                                        )
                                                    }
                                                })
                                            }
                                        </TextField>
                            </Grid>
                        </React.Fragment>:null
                    }        
                    {
                        zonaSelected.ppoeList &&
                        <React.Fragment>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                                <TextField 
                                    id='UserPPOE'
                                    fullWidth
                                    label='UserPPOE'
                                    value={DatosD.UserPPOE || ''}
                                    InputProps={{
                                        startAdornment:<DnsIcon/>
                                    }}
                                    onChange={handleDatosIdMikrotik}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                                <TextField 
                                    id='PassPPOE'
                                    fullWidth
                                    label='PassPPOE'
                                    value={DatosD.PassPPOE || ''}
                                    InputProps={{
                                        startAdornment:<DnsIcon/>
                                    }}
                                    onChange={handleDatos}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                        </React.Fragment>
                    }           
                    <Grid item lg={4} md={6} sm={6} xs={12} > 
                        <TextField 
                            id='Instalacion'
                            fullWidth
                            label='Instalacion'
                            value={DatosD.Instalacion || ''}
                            InputProps={{ startAdornment:<DnsIcon/>}}
                            onChange={handleDatosInstalacion}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='date'
                        />                     
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} >
                        <TextField 
                            id='UserMk'
                            fullWidth
                            label='UserMk'
                            value={DatosD.UserMk || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} >
                        <TextField 
                            id='PassMk'
                            fullWidth
                            label='PassMk'
                            value={DatosD.PassMk || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            margin='dense'
                            size='small'
                        />
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TooltipAntd title="EN MESES" color='blue'>
                            <TextField 
                                id='TiempoPermanencia'
                                fullWidth
                                label='Tiempo de Permanencia'
                                value={DatosD.TiempoPermanencia || ''}
                                onChange={handleDatos}
                                variant='outlined'
                                margin='dense'
                                size='small'
                                type='number'
                                placeholder='Meses'
                            />
                        </TooltipAntd>
                    </Grid>   
                    <Grid item lg={2} md={6} sm={6} xs={12} > 
                        <TextField 
                            id='HoraInstalacion'
                            fullWidth
                            label='HoraInstalacion'
                            value={DatosD.HoraInstalacion || ''}
                            InputProps={{ startAdornment:<DnsIcon/> }}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='time'
                        />                     
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='ValorInstalacion'
                            fullWidth
                            label='ValorInstalacion'
                            value={DatosD.ValorInstalacion}
                            InputProps={{ startAdornment:<MonetizationOnIcon/> }}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='Number'
                        />    
                    </Grid>  
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='ValorInstalacionCompleta'
                            fullWidth
                            label='Instalacion Completa'
                            value={DatosD.ValorInstalacionCompleta}
                            InputProps={{
                                startAdornment:<MonetizationOnIcon/>
                            }}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='Number'
                        />    
                    </Grid>                             
                    <Grid item lg={2} md={6} sm={6} xs={12} > 
                        <TextField 
                            id='DiaNotificacion'
                            fullWidth
                            label='Dia Notificacion'
                            InputProps={{ startAdornment:<DnsIcon/> }}
                            value={DatosD.DiaNotificacion || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='number'
                        />                     
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} > 
                        <TextField 
                            id='DiasCorte'
                            fullWidth
                            label='Dias Corte'
                            InputProps={{ startAdornment:<DnsIcon/> }}
                            value={DatosD.DiasCorte || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='number'
                        />                     
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                        <TextField 
                            id='TecnicoAsignado'
                            fullWidth
                            label='Tecnico'
                            value={DatosD.TecnicoAsignado || ''}
                            onChange={handleDatosSelect}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            select
                        >
                            {
                                getTecnicos.map(el=> el.NombresReducidos).map((el, index)=>                                   
                                <MenuItem value={el} key={`Tecnico_${index}_${el}`}>
                                    {el}
                                </MenuItem>
                                )
                            }
                        </TextField>
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                        <TextField 
                            id='NameWifi'
                            fullWidth
                            label='NameWifi'
                            value={DatosD.NameWifi || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                        <TextField 
                            id='PassWifi'
                            fullWidth
                            label='PassWifi'
                            value={DatosD.PassWifi || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                        <TextField 
                            id='Comentario'
                            fullWidth
                            label='Comentario'
                            value={DatosD.Comentario || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={6} xs={12} style={{alignSelf:'center', paddingTop:7, display:'flex', flexDirection:'row'}}>
                        <Card style={{height:50, display:'flex', flexDirection:'row', alignItems:'center',justifyContent:'center', margin:'dense', alignSelf:'center', width:'100%'}} >
                            <CardContent style={{alignSelf:'center', paddingTop:25}}>
                                INST.:
                                Completo
                                <Switch
                                    checked={DatosD.StatusIns}
                                    onChange={handleStatusIns}
                                    color="primary"
                                    name="checkedB"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                                Parcial
                                {
                                    DatosD.StatusIns && 
                                    <React.Fragment>
                                        {
                                            isNewService && 
                                            <TextField 
                                                id='AvanceInstalacion'
                                                label='Avance'
                                                value={getAvance}
                                                onChange={({target})=>setAvance(target.value)}
                                                //variant='outlined'
                                                size='small'
                                                margin='dense'
                                                type='Number'
                                                style={{marginLeft:25, marginTop:-8, width:100}}
                                            />  
                                        }
                                    </React.Fragment>
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item sm={6} xs={12} >
                        <Card style={{height:50, display:'flex', flexDirection:'row', alignItems:'center',justifyContent:'center'}}>
                            <CardContent>
                                <Typography component="div" style={{width:'100%'}}>
                                    <Grid component="label" container alignItems="center" spacing={1} justifyContent='center'>
                                        <Grid item>PostPago</Grid>
                                        <Grid item>
                                        <Switch
                                            checked={DatosD.TipoPagoBoolean}
                                            onChange={handleTipoPago}
                                            color="primary"
                                            name="checkPago"
                                            id='checkPago'
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                        </Grid>
                                        <Grid item>PrePago</Grid>
                                    </Grid>
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item sm={6} xs={12} >
                        <Card style={{height:50, display:'flex', flexDirection:'row', alignItems:'center',justifyContent:'center'}}>
                            <CardContent>
                                <Typography component="div" style={{width:'100%'}}>
                                    <Grid component="label" container alignItems="center" spacing={1} justifyContent='center'>
                                        <Grid item>CORTE:</Grid>
                                        <Grid item>Manual</Grid>
                                        <Grid item>
                                        <Switch
                                            checked={DatosD.CorteAutomatico}
                                            onChange={handleCorteAutomatico}
                                            color="primary"
                                            name="CorteAutomatico"
                                            id='CorteAutomatico'
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                        </Grid>
                                        <Grid item>Automatico</Grid>
                                    </Grid>
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item sm={6} xs={12} >
                        <Paper style={{minHeight:300}} elevation={3}>
                        < div
                            ref={ mapDiv }
                            style={{width:'100%', height:'100%', minHeight:300}} 
                        />
                        </Paper>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    )
});

export default ElementServiciosRadio;